import {
  CouponModal,
  AddLearner,
  EmailVerificationCheckModal,
  PpsModal,
  CouponApplied,
  CartItemsValidate,
  CheckOutValidateModal,
  MemberpriceApplied,
  CouponNotAllowed,
} from '../components/modal';
import CartService from '../service/CartService';
import cartService from '../service/CartService';

export default class Checkout extends React.Component {
  constructor(props) {
    super(props);
    if (_buyNow) {
      var index = _buyNowDetails.type + '_' + _buyNowDetails.id;
      var cart = {};
      cart[index] = _buyNowDetails;
      this.state = {
        priceObj: _bfo == 0 ? this.checkoutCalculationsForBulkPurchaseDisable(cart) : this.checkout_calculations(cart),
        showpopup: false,
        showpopup2: true,
        memberPopup: false,
        couponApplied: false,
        cartcount: 1,
        carttotal: _buyNowDetails.others.base_price,
        cart: cart,
        showEmilVerifyModal: false,
        showPpsModal: false,
        govtIdCardLablel: 'PPS',
        showCheckOutValidateModal: false,
        showCheckOutValidateModalMsg: '',
        appUpdateState: '',
        asktoapply: false,
        discount: false
      };
    } else {
      this.state = {
        priceObj: _bfo == 0 ? this.checkoutCalculationsForBulkPurchaseDisable(cartService.getCart()) : this.checkout_calculations(cartService.getCart()),
        showpopup: false,
        showpopup2: true,
        memberPopup: false,
        couponApplied: false,
        cartcount: this.props.data.cartcount,
        carttotal: this.props.data.price,
        cart: this.props.data.items,
        showEmilVerifyModal: false,
        showPpsModal: false,
        govtIdCardLablel: 'PPS',
        showCartItemValidateModal: false,
        expiredCartItems: [],
        appUpdateState: '',
        asktoapply: false,
        discount: false
      };
    }
  }

  checkout_calculations = (cart) => {

    var total_main_price = 0;
    var total_base_price = 0;
    var total_tax = 0;
    var tax_type = 0;
    var total_cp_dis = 0;
    var total_dis = 0;
    var total_price = 0;
    var total_tax_avg = 0;
    var courseFound = 0;

    var total_items = Object.keys(cart).length;
    var isflagset = 0;
    let pre_cp_dis = 0;
    var pre_total = 0;
    var coupon_applied_pre_total = 0;
    // var actual_pre_total = 0;
    /* FOR DISCOUNT TYPE PERCENTAGE */
    Object.keys(cart).map((key) => {
      if (cart[key].others.discount_type && cart[key].others.discount_type == '1' && Number(cart[key].others.discount_percent) > 0) {
        cart[key].others.discount_price = Number(cart[key].others.price) - (Number(cart[key].others.discount_price))
      }
    })
    
    if (_couponApplied.data)
    {
      var is_coupon_limit_count_set            = (Number(_couponApplied.data.pc_subscriber_coupons_limit) > 0) ? true : false;

      if (is_coupon_limit_count_set)
      {
        var coupon_limit_remaining_found         = 1;
        var coupon_limit_remaining_count         = _couponApplied.data.pc_subscriber_coupons_remaining;
        var coupon_limit_remaining  = localStorage.getItem('limit_remaining_coupon');

        if (!coupon_limit_remaining || (typeof coupon_limit_remaining !== 'undefined'))
        {
          localStorage.setItem('limit_remaining_coupon', _couponApplied.data.pc_subscriber_coupons_remaining);
          coupon_limit_remaining = localStorage.getItem('limit_remaining_coupon');
        }

        //-----------
        
        var limit_discount_remaining_coupon  = localStorage.getItem('limit_discount_remaining_coupon');
        if (!limit_discount_remaining_coupon || (typeof limit_discount_remaining_coupon !== 'undefined'))
        {
          localStorage.setItem('limit_discount_remaining_coupon', _couponApplied.data.pc_subscriber_coupons_remaining);
          limit_discount_remaining_coupon = localStorage.getItem('limit_discount_remaining_coupon');
        }

        //-----------
        
        var limit_discount_custom_coupon  = localStorage.getItem('limit_discount_custom_coupon');

        if (!limit_discount_custom_coupon || (typeof limit_discount_custom_coupon !== 'undefined'))
        {
          localStorage.setItem('limit_discount_custom_coupon', _couponApplied.data.pc_subscriber_coupons_remaining);
          limit_discount_custom_coupon = localStorage.getItem('limit_discount_custom_coupon');
        }

      }
    } 
    let total_pre_cp_dis = {};
    if (_couponApplied.slug && _couponApplied.data.pc_coupon_type == 0) {

      
      //platform coupon
      /*old_code
        Object.keys(cart).map((index) => {
          var qty =
            Object.keys(cart[index].learners).length > 0
              ? Object.keys(cart[index].learners).length
              : 1;
          pre_total +=
            Number(
              cart[index].others.discount_price != 0
                ? cart[index].others.discount_price
                : cart[index].others.price
            ) * qty;
          // actual_pre_total += Number(cart[index].others.discount_price);
        });


        Object.keys(cart).map((cont_index) => {

          var qty =
            Object.keys(cart[cont_index].learners).length > 0
              ? Object.keys(cart[cont_index].learners).length
              : 1;

          cart[cont_index].contribution =
            ((cart[cont_index].others.discount_price != 0
              ? cart[cont_index].others.discount_price
              : cart[cont_index].others.price) *
              qty) /
            pre_total;

          cart[cont_index].tax_amount =
            cart[cont_index].others.base_price *
            qty *
            (cart[cont_index].others.taxes.total_tax / 100);

          cart[cont_index].actual_tax_amount =
            cart[cont_index].others.tax_method == '0'
              ? 0
              : cart[cont_index].others.base_price *
                qty *
                (cart[cont_index].others.taxes.total_tax / 100);
        });
      old_code*/
      

      Object.keys(cart).map((index) => {
        if (Object.keys(cart[index].learners).length > 0) {
          Object.keys(cart[index].learners).map((items) => {
            //PRE TOTAL
            //For Membership
            if (
              cart[index].learners[items]['is_member'] == '1' &&
              _showMember == '1' &&
              cart[index].others.member_status == '1'
            ) {
              pre_total += Number(cart[index].others.member_price);
            } else { //For Non-Membership
                pre_total += Number(
                cart[index].others.discount_price != 0
                  ? cart[index].others.discount_price
                  : cart[index].others.price
              );
              
            }

            //COUPON APPLIED PRE TOTAL
            if(coupon_limit_remaining_found && coupon_limit_remaining > 0) {

              if(_couponApplied.data.pc_coupon_option == 2) {
                //For Membership
                if (
                  cart[index].learners[items]['is_member'] == '1' &&
                  _showMember == '1' &&
                  cart[index].others.member_status == '1'
                ) {
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {

                    if (coupon_limit_remaining > 0)
                    {
                      coupon_applied_pre_total += Number(cart[index].others.member_price);
                      --coupon_limit_remaining;
                    } else {
                      coupon_applied_pre_total += 0;
                    }
                    
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                } else { //For Non-Membership
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {

                    if (coupon_limit_remaining > 0)
                    {
                      coupon_applied_pre_total += Number(
                        cart[index].others.discount_price != 0
                          ? cart[index].others.discount_price
                          : cart[index].others.price
                      );
                      --coupon_limit_remaining;
                    } else {
                      coupon_applied_pre_total += 0;
                    }
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
                
              } else if(_couponApplied.data.pc_coupon_option == 1) {
                if (
                  cart[index].learners[items]['is_member'] == '1' &&
                  _showMember == '1' &&
                  cart[index].others.member_status == '1'
                ) {
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                    if (coupon_limit_remaining > 0)
                    {
                      coupon_applied_pre_total += Number(cart[index].others.member_price);
                      --coupon_limit_remaining;
                    } else {
                      coupon_applied_pre_total += 0;
                    }
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
              } else if(_couponApplied.data.pc_coupon_option == 0) {
                if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                  
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                    if (coupon_limit_remaining > 0)
                    {
                      coupon_applied_pre_total += Number(
                        cart[index].others.discount_price != 0
                          ? cart[index].others.discount_price
                          : cart[index].others.price
                      );
                      --coupon_limit_remaining;
                    }
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
                
              }
              localStorage.setItem('limit_remaining_coupon', coupon_limit_remaining);
            
            } else if (!is_coupon_limit_count_set){
              if(_couponApplied.data.pc_coupon_option == 2) {
                //For Membership
                if (
                  cart[index].learners[items]['is_member'] == '1' &&
                  _showMember == '1' &&
                  cart[index].others.member_status == '1'
                ) {
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                      coupon_applied_pre_total += Number(cart[index].others.member_price);
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                } else { //For Non-Membership
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                    coupon_applied_pre_total += Number(
                      cart[index].others.discount_price != 0
                        ? cart[index].others.discount_price
                        : cart[index].others.price
                    );
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
              } else if(_couponApplied.data.pc_coupon_option == 1) {
                if (
                  cart[index].learners[items]['is_member'] == '1' &&
                  _showMember == '1' &&
                  cart[index].others.member_status == '1'
                ) {
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                      coupon_applied_pre_total += Number(cart[index].others.member_price);
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
              } else if(_couponApplied.data.pc_coupon_option == 0) {
                if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                        coupon_applied_pre_total += Number(
                        cart[index].others.discount_price != 0
                          ? cart[index].others.discount_price
                          : cart[index].others.price
                      );
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
              }
            }
          });
        } else {
          if (cart[index].others.member_status == '1' && _validMember == '1') {
            pre_total += Number(cart[index].others.member_price);
          } else {
            pre_total += Number(
              cart[index].others.discount_price != 0
                ? cart[index].others.discount_price
                : cart[index].others.price
            );
          }
        }
      });

      var tempContribution = 0;
      var tempTaxAmount = 0;
      var tempActualTaxAmount = 0;
      //let pre_cp_dis=0;
      Object.keys(cart).map((cont_index) => {
        if (Object.keys(cart[cont_index].learners).length > 0) {
          tempContribution = 0;
          tempTaxAmount = 0;
          tempActualTaxAmount = 0;
          Object.keys(cart[cont_index].learners).map((items) => {
            if (
              cart[cont_index].learners[items]['is_member'] == '1' &&
              _showMember == '1' &&
              cart[cont_index].others.member_status == '1'
            ) {
              tempContribution += parseFloat(
                cart[cont_index].others.member_price
              );
              tempTaxAmount += parseFloat(
                cart[cont_index].others.member_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );
              tempActualTaxAmount += parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.member_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            } else {
              tempContribution += parseFloat(
                cart[cont_index].others.discount_price != 0
                  ? cart[cont_index].others.discount_price
                  : cart[cont_index].others.price
              );

              tempTaxAmount += parseFloat(
                cart[cont_index].others.base_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );

              tempActualTaxAmount += parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.base_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            }
          });
        } else {
          if (
            cart[cont_index].others.member_status == '1' &&
            _validMember == '1'
          ) {
            tempContribution = parseFloat(cart[cont_index].others.member_price);
            tempTaxAmount = parseFloat(
              cart[cont_index].others.member_price *
                (cart[cont_index].others.taxes.total_tax / 100)
            );
            tempActualTaxAmount = parseFloat(
              cart[cont_index].others.tax_method == '0'
                ? 0
                : cart[cont_index].others.member_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
            );
          } else {
            tempContribution = parseFloat(
              cart[cont_index].others.discount_price != 0
                ? cart[cont_index].others.discount_price
                : cart[cont_index].others.price
            );
            tempTaxAmount = parseFloat(
              cart[cont_index].others.base_price *
                (cart[cont_index].others.taxes.total_tax / 100)
            );
            tempActualTaxAmount = parseFloat(
              cart[cont_index].others.tax_method == '0'
                ? 0
                : cart[cont_index].others.base_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
            );
          }
        }
        cart[cont_index].contribution = parseFloat(
          pre_total > 0 ? tempContribution / pre_total : tempContribution
        );
        
        cart[cont_index].tax_amount = tempTaxAmount;
        cart[cont_index].actual_tax_amount = tempActualTaxAmount;
      });
     
      // DISCOUNT CALCULATION
      if (_couponApplied.data.pc_discount_type == 0) {
        let amounToApplyDiscount;
        if(_couponApplied.data.pc_coupon_option !== 2) {
          amounToApplyDiscount = coupon_applied_pre_total;
        } else {
          amounToApplyDiscount = pre_total;
        }

        if(_couponApplied.data.pc_is_bulk_learner_percent == 1) {

          Object.keys(cart).map((index) => {
            total_pre_cp_dis[index] = 0;
            let total_pre_cp_discount =0;
            if (Object.keys(cart[index].learners).length > 0) {
              Object.keys(cart[index].learners).map((items) => {
                if(limit_discount_remaining_coupon && limit_discount_remaining_coupon > 0)
                {
                  if(_couponApplied.data.pc_coupon_option == 2) {
                    //For Membership
                    if (cart[index].learners[items].is_member) 
                    {
                      if (_couponApplied.data.pc_maximum_discount)
                      {
                        pre_cp_dis += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                      Number(_couponApplied.data.pc_maximum_discount) :
                                      Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;

                        total_pre_cp_discount += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                                  Number(_couponApplied.data.pc_maximum_discount) :
                                                  Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                      } else {
                        pre_cp_dis += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        total_pre_cp_discount += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                      }
                      
                    } else { //For Non-Membership
                      if (_couponApplied.data.pc_maximum_discount)
                      {
                        if (cart[index].others.discount_price != 0) {
                          pre_cp_dis += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100

                          total_pre_cp_discount += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100
                                      
                        } else {
                          pre_cp_dis += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100
                          total_pre_cp_discount += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100
                        }
                      } else {
                        if (cart[index].others.discount_price != 0) {
                          pre_cp_dis += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        } else {
                          pre_cp_dis += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        }
                      }
                    }
                    total_pre_cp_dis[index] = total_pre_cp_discount;
                    --limit_discount_remaining_coupon;
                    
                  } else if(_couponApplied.data.pc_coupon_option == 1) {
                    if (
                      cart[index].learners[items]['is_member'] == '1' &&
                      _showMember == '1' &&
                      cart[index].others.member_status == '1'
                    ) {
                        if (_couponApplied.data.pc_maximum_discount)
                        {
                          pre_cp_dis += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                                      Number(_couponApplied.data.pc_maximum_discount) :
                                                      Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        } else {
                          pre_cp_dis += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                        --limit_discount_remaining_coupon;
                      } else {
                        pre_cp_dis += Number(0);
                      }
                  } else if (_couponApplied.data.pc_coupon_option == 0) {
                    if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) 
                    {
                      if (_couponApplied.data.pc_maximum_discount)
                      {
                        if (cart[index].others.discount_price != 0) {
                          pre_cp_dis += Number(cart[index].others.discount_price * Number(_couponApplied.data.pc_discount_rate) / 100) > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100

                          total_pre_cp_discount += Number(cart[index].others.discount_price * Number(_couponApplied.data.pc_discount_rate) / 100) > Number(_couponApplied.data.pc_maximum_discount) ? 
                                                  Number(_couponApplied.data.pc_maximum_discount) :
                                                  Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        } else {
                          pre_cp_dis += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100 > (_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100

                          total_pre_cp_discount += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100 > (_couponApplied.data.pc_maximum_discount) ? 
                          Number(_couponApplied.data.pc_maximum_discount) :
                          Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100
                        }
                      } else {
                        if (cart[index].others.discount_price != 0) {
                          pre_cp_dis += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        } else {
                          pre_cp_dis += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        }
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                      --limit_discount_remaining_coupon;
                    } else {
                      pre_cp_dis += 0;
                    }
                  }
                  localStorage.setItem('limit_discount_remaining_coupon', limit_discount_remaining_coupon);
                } else if (!is_coupon_limit_count_set ) {
                  if(_couponApplied.data.pc_coupon_option == 2) {
                    //For Membership
                    if (cart[index].learners[items].is_member) 
                    {
                      if (_couponApplied.data.pc_maximum_discount)
                      {
                        pre_cp_dis += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                      Number(_couponApplied.data.pc_maximum_discount) :
                                      Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        total_pre_cp_discount += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                      Number(_couponApplied.data.pc_maximum_discount) :
                                      Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                      } else {
                        pre_cp_dis += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        total_pre_cp_discount += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                      }
                      
                    } else { //For Non-Membership
                      if (_couponApplied.data.pc_maximum_discount)
                      {
                        if (cart[index].others.discount_price != 0) {
                          pre_cp_dis += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100
                          
                          total_pre_cp_discount += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100
                        } else {
                          pre_cp_dis += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100

                          total_pre_cp_discount += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100
                        }
                      } else {
                        if (cart[index].others.discount_price != 0) {
                          pre_cp_dis += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        } else {
                          pre_cp_dis += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        }
                      }
                    }
                    total_pre_cp_dis[index] = total_pre_cp_discount;
                    
                  } else if(_couponApplied.data.pc_coupon_option == 1) {
                    if (
                      cart[index].learners[items]['is_member'] == '1' &&
                      _showMember == '1' &&
                      cart[index].others.member_status == '1'
                    ) {
                        if (_couponApplied.data.pc_maximum_discount)
                        {
                          pre_cp_dis += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100 > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        } else {
                          pre_cp_dis += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.member_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                      } else {
                        pre_cp_dis += Number(0);
                      }
                  } else if (_couponApplied.data.pc_coupon_option == 0) {
                    if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) 
                    {
                      if (_couponApplied.data.pc_maximum_discount)
                      {
                        if (cart[index].others.discount_price != 0) {
                          pre_cp_dis += Number(cart[index].others.discount_price * Number(_couponApplied.data.pc_discount_rate) / 100) > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100
                          total_pre_cp_discount += Number(cart[index].others.discount_price * Number(_couponApplied.data.pc_discount_rate) / 100) > Number(_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100
                        } else {
                          pre_cp_dis += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100 > (_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100

                          total_pre_cp_discount += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100 > (_couponApplied.data.pc_maximum_discount) ? 
                                        Number(_couponApplied.data.pc_maximum_discount) :
                                        Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100
                        }
                      } else {
                        if (cart[index].others.discount_price != 0) {
                          pre_cp_dis += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.discount_price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        } else {
                          pre_cp_dis += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                          total_pre_cp_discount += Number(cart[index].others.price) * Number(_couponApplied.data.pc_discount_rate) / 100;
                        }
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                    } else {
                      pre_cp_dis += 0;
                    }
                  }
                }

              });
            }
          });
          
        } else {
          pre_cp_dis = 0;
        }

      } else {
        if(_couponApplied.data.pc_is_bulk_learner_price == 1) {
          Object.keys(cart).map((index) => {
            total_pre_cp_dis[index] = 0;
            let total_pre_cp_discount = 0;
            if (Object.keys(cart[index].learners).length > 0) {
              Object.keys(cart[index].learners).map((items) => {

                if(limit_discount_remaining_coupon && limit_discount_remaining_coupon > 0)
                {
                  if(_couponApplied.data.pc_coupon_option == 2) {
                    //For Membership
                    if (
                      cart[index].learners[items]['is_member'] == '1' &&
                      _showMember == '1' &&
                      cart[index].others.member_status == '1'
                    ) {
                      pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.member_price) ? 
                                        Number(cart[index].others.member_price) : 
                                        Number(_couponApplied.data.pc_discount_rate);
                      total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.member_price) ? 
                                        Number(cart[index].others.member_price) : 
                                        Number(_couponApplied.data.pc_discount_rate);
                      
                    } else { //For Non-Membership
                      if (cart[index].others.discount_price != 0) {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.discount_price) ? 
                                              Number(cart[index].others.discount_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.discount_price) ? 
                                              Number(cart[index].others.discount_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      } else {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.price) ? 
                                              Number(cart[index].others.price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.price) ? 
                                              Number(cart[index].others.price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      }
                    }
                    total_pre_cp_dis[index] = total_pre_cp_discount;
                    --limit_discount_remaining_coupon;
                    
                  } else if(_couponApplied.data.pc_coupon_option == 1) {
                    if (
                      cart[index].learners[items]['is_member'] == '1' &&
                      _showMember == '1' &&
                      cart[index].others.member_status == '1'
                    ) {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.member_price) ? 
                                              Number(cart[index].others.member_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.member_price) ? 
                                              Number(cart[index].others.member_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                        --limit_discount_remaining_coupon;
                    } else {
                      pre_cp_dis += 0;
                    }
                  } else if(_couponApplied.data.pc_coupon_option == 0) {
                    if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                      if (cart[index].others.discount_price != 0) {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.discount_price) ? 
                                              Number(cart[index].others.discount_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.discount_price) ? 
                                              Number(cart[index].others.discount_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      } else {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.price) ? 
                                              Number(cart[index].others.price) : 
                                              Number(_couponApplied.data.pc_discount_rate);

                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.price) ? 
                                              Number(cart[index].others.price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount
                      --limit_discount_remaining_coupon;
                    } else {
                      pre_cp_dis += 0;
                    }
                  }
                  localStorage.setItem('limit_discount_remaining_coupon', limit_discount_remaining_coupon);
                } else if (!is_coupon_limit_count_set ) {
                  if(_couponApplied.data.pc_coupon_option == 2) {
                    //For Membership
                    if (
                      cart[index].learners[items]['is_member'] == '1' &&
                      _showMember == '1' &&
                      cart[index].others.member_status == '1'
                    ) {
                      pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.member_price) ? 
                                              Number(cart[index].others.member_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.member_price) ? 
                                              Number(cart[index].others.member_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                    } else { //For Non-Membership
                      if (cart[index].others.discount_price != 0) {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.discount_price) ? 
                                              Number(cart[index].others.discount_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.discount_price) ? 
                                              Number(cart[index].others.discount_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      } else {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.price) ? 
                                              Number(cart[index].others.price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.price) ? 
                                              Number(cart[index].others.price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      }
                    }
                    total_pre_cp_dis[index] = total_pre_cp_discount;
                  } else if(_couponApplied.data.pc_coupon_option == 1) {
                    if (
                      cart[index].learners[items]['is_member'] == '1' &&
                      _showMember == '1' &&
                      cart[index].others.member_status == '1'
                    ) {
                      pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.member_price) ? 
                                            Number(cart[index].others.member_price) : 
                                            Number(_couponApplied.data.pc_discount_rate);
                      total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.member_price) ? 
                                            Number(cart[index].others.member_price) : 
                                            Number(_couponApplied.data.pc_discount_rate);
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                    } else {
                      pre_cp_dis += 0;
                    }
                  } else if(_couponApplied.data.pc_coupon_option == 0) {
                    if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                      if (cart[index].others.discount_price != 0) {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.discount_price) ? 
                                              Number(cart[index].others.discount_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.discount_price) ? 
                                              Number(cart[index].others.discount_price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      } else {
                        pre_cp_dis += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.price) ? 
                                              Number(cart[index].others.price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                        total_pre_cp_discount += (Number(_couponApplied.data.pc_discount_rate) > cart[index].others.price) ? 
                                              Number(cart[index].others.price) : 
                                              Number(_couponApplied.data.pc_discount_rate);
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                    } else {
                      pre_cp_dis += 0;
                    }
                  }
                }

              })
            }
          });
        } else {
          pre_cp_dis = 0;
        }
      }
    } else if (
      _couponApplied.data &&
      _couponApplied.data.pc_customized_data &&
      _couponApplied.data.pc_coupon_type == 1
    ) {
      var pc_customized_data = _couponApplied.data.pc_customized_data.replace(
        new RegExp('training_event_', 'g'),
        'booking_event_'
      );
      /*old_code 
      Object.keys(cart).map((index) => {
        var qty =
          Object.keys(cart[index].learners).length > 0
            ? Object.keys(cart[index].learners).length
            : 1;
        var testflag = false;
        if (cart[index].type == 'booking_event') {
          testflag =
            pc_customized_data.search(
              'training_course_' + cart[index].course_id
            ) != -1;
        }
        if (pc_customized_data.search(index) != -1 || testflag) {
          courseFound = 1;
          pre_total +=
            Number(
              cart[index].others.discount_price != 0
                ? cart[index].others.discount_price
                : cart[index].others.price
            ) * qty;
        }
        // actual_pre_total += Number(cart[index].others.discount_price);
      });

      Object.keys(cart).map((cont_index) => {
        var qty =
          Object.keys(cart[cont_index].learners).length > 0
            ? Object.keys(cart[cont_index].learners).length
            : 1;
        var testflag = false;
        if (cart[cont_index].type == 'booking_event') {
          testflag =
            pc_customized_data.search(
              'training_course_' + cart[cont_index].course_id
            ) != -1;
        }
        if (pc_customized_data.search(cont_index) != -1 || testflag) {
          courseFound = 1;
          cart[cont_index].contribution =
            ((cart[cont_index].others.discount_price != 0
              ? cart[cont_index].others.discount_price
              : cart[cont_index].others.price) *
              qty) /
            pre_total;
          cart[cont_index].tax_amount =
            cart[cont_index].others.base_price *
            qty *
            (cart[cont_index].others.taxes.total_tax / 100);
          cart[cont_index].actual_tax_amount =
            cart[cont_index].others.tax_method == '0'
              ? 0
              : cart[cont_index].others.base_price *
                qty *
                (cart[cont_index].others.taxes.total_tax / 100);
        } else {
          cart[cont_index].contribution = 0;
          cart[cont_index].tax_amount =
            cart[cont_index].others.base_price *
            qty *
            (cart[cont_index].others.taxes.total_tax / 100);
          cart[cont_index].actual_tax_amount =
            cart[cont_index].others.tax_method == '0'
              ? 0
              : cart[cont_index].others.base_price *
                qty *
                (cart[cont_index].others.taxes.total_tax / 100);
        }
      });
      old_code */

      Object.keys(cart).map((index) => {
        var testflag = false;
        if (cart[index].type == 'booking_event') {
          testflag =
            pc_customized_data.search(
              'training_course_' + cart[index].course_id
            ) != -1;
        }
        if (pc_customized_data.search(index) != -1 || testflag) {
          courseFound = 1;
          if (Object.keys(cart[index].learners).length > 0) {
            Object.keys(cart[index].learners).map((items) => {
              //PRE_TOTAL:
              if (
                cart[index].learners[items]['is_member'] == '1' &&
                _showMember == '1' &&
                cart[index].others.member_status == '1'
              ) {
                pre_total += Number(cart[index].others.member_price);
              } else {
                pre_total += Number(
                  cart[index].others.discount_price != 0
                    ? cart[index].others.discount_price
                    : cart[index].others.price
                );
              }

              //COUPON APPLIED PRE TOTAL
              
              if(_couponApplied.data.pc_coupon_option == 2) {
                //For Membership
                if (
                  cart[index].learners[items]['is_member'] == '1' &&
                  _showMember == '1' &&
                  cart[index].others.member_status == '1'
                ) {
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                    coupon_applied_pre_total += Number(cart[index].others.member_price);
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                } else { //For Non-Membership
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                    coupon_applied_pre_total += Number(
                    cart[index].others.discount_price != 0
                      ? cart[index].others.discount_price
                      : cart[index].others.price
                  );
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
              } else if(_couponApplied.data.pc_coupon_option == 1) {
                if (
                  cart[index].learners[items]['is_member'] == '1' &&
                  _showMember == '1' &&
                  cart[index].others.member_status == '1'
                ) {
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                    coupon_applied_pre_total += Number(cart[index].others.member_price);
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
              } else if(_couponApplied.data.pc_coupon_option == 0) {
                if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                  if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                    coupon_applied_pre_total += Number(
                    cart[index].others.discount_price != 0
                      ? cart[index].others.discount_price
                      : cart[index].others.price
                  );
                  } else {
                    coupon_applied_pre_total += 0;
                  }
                }
              }

            });
          } else {
            if (
              cart[index].others.member_status == '1' &&
              _validMember == '1'
            ) {
              pre_total += Number(cart[index].others.member_price);
            } else {
              pre_total += Number(
                cart[index].others.discount_price != 0
                  ? cart[index].others.discount_price
                  : cart[index].others.price
              );
            }
          }
        }
      });

      var tempContribution = 0;
      var tempTaxAmount = 0;
      var tempActualTaxAmount = 0;

      Object.keys(cart).map((cont_index) => {
        var testflag = false;
        if (cart[cont_index].type == 'booking_event') {
          testflag =
            pc_customized_data.search(
              'training_course_' + cart[cont_index].course_id
            ) != -1;
        }
        if (pc_customized_data.search(cont_index) != -1 || testflag) {
          courseFound = 1;
          tempContribution = 0;
          tempTaxAmount = 0;
          tempActualTaxAmount = 0;
          if (Object.keys(cart[cont_index].learners).length > 0) {
            Object.keys(cart[cont_index].learners).map((items) => {
              if (
                cart[cont_index].learners[items]['is_member'] == '1' &&
                _showMember == '1' &&
                cart[cont_index].others.member_status == '1'
              ) {
                tempContribution += parseFloat(
                  cart[cont_index].others.member_price
                );
                tempTaxAmount += parseFloat(
                  cart[cont_index].others.member_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
                );
                tempActualTaxAmount += parseFloat(
                  cart[cont_index].others.tax_method == '0'
                    ? 0
                    : cart[cont_index].others.member_price *
                        (cart[cont_index].others.taxes.total_tax / 100)
                );
              } else {
                tempContribution += parseFloat(
                  cart[cont_index].others.discount_price != 0
                    ? cart[cont_index].others.discount_price
                    : cart[cont_index].others.price
                );

                tempTaxAmount += parseFloat(
                  cart[cont_index].others.base_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
                );

                tempActualTaxAmount += parseFloat(
                  cart[cont_index].others.tax_method == '0'
                    ? 0
                    : cart[cont_index].others.base_price *
                        (cart[cont_index].others.taxes.total_tax / 100)
                );
              }
            });
          } else {
            if (
              cart[cont_index].others.member_status == '1' &&
              _validMember == '1'
            ) {
              tempContribution = parseFloat(
                cart[cont_index].others.member_price
              );
              tempTaxAmount = parseFloat(
                cart[cont_index].others.member_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );
              tempActualTaxAmount = parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.member_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            } else {
              tempContribution = parseFloat(
                cart[cont_index].others.discount_price != 0
                  ? cart[cont_index].others.discount_price
                  : cart[cont_index].others.price
              );

              tempTaxAmount = parseFloat(
                cart[cont_index].others.base_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );

              tempActualTaxAmount = parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.base_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            }
          }
          cart[cont_index].contribution = parseFloat(
            pre_total > 0 ? tempContribution / pre_total : tempContribution
          );
          cart[cont_index].tax_amount = tempTaxAmount;
          cart[cont_index].actual_tax_amount = tempActualTaxAmount;
        } else {
          tempContribution = 0;
          tempTaxAmount = 0;
          tempActualTaxAmount = 0;
          if (Object.keys(cart[cont_index].learners).length > 0) {
            Object.keys(cart[cont_index].learners).map((items) => {
              if (
                cart[cont_index].learners[items]['is_member'] == '1' &&
                _showMember == '1' &&
                cart[cont_index].others.member_status == '1'
              ) {
                tempContribution += 0;
                tempTaxAmount += parseFloat(
                  cart[cont_index].others.member_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
                );
                tempActualTaxAmount += parseFloat(
                  cart[cont_index].others.tax_method == '0'
                    ? 0
                    : cart[cont_index].others.member_price *
                        (cart[cont_index].others.taxes.total_tax / 100)
                );
              } else {
                tempContribution += 0;
                tempTaxAmount += parseFloat(
                  cart[cont_index].others.base_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
                );
                tempActualTaxAmount += parseFloat(
                  cart[cont_index].others.tax_method == '0'
                    ? 0
                    : cart[cont_index].others.base_price *
                        (cart[cont_index].others.taxes.total_tax / 100)
                );
              }
            });
          } else {
            if (
              cart[cont_index].others.member_status == '1' &&
              _validMember == '1'
            ) {
              tempContribution = 0;
              tempTaxAmount = parseFloat(
                cart[cont_index].others.member_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );
              tempActualTaxAmount = parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.member_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            } else {
              tempContribution = 0;
              tempTaxAmount = parseFloat(
                cart[cont_index].others.base_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );
              tempActualTaxAmount = parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.base_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            }
          }
          cart[cont_index].contribution = parseFloat(
            pre_total > 0 ? tempContribution / pre_total : tempContribution
          );
          cart[cont_index].tax_amount = tempTaxAmount;
          cart[cont_index].actual_tax_amount = tempActualTaxAmount;
        }
      });

      /*newcode   newcode*/
      if (_couponApplied.data.pc_discount_type == 0) {
        let amounToApplyDiscount;
        if(_couponApplied.data.pc_coupon_option !== 2) {
          amounToApplyDiscount = coupon_applied_pre_total;
        } else {
          amounToApplyDiscount = pre_total;
        }
       
        if(_couponApplied.data.pc_is_bulk_learner_percent == 1) {
          //is_custom
          let is_custom = (_couponApplied.data.pc_customized_data != "") ? 1 : 0;
          if(is_custom) {
            
            Object.keys(cart).map((index) => {
              let item_name = '';
              let customized_data = JSON.parse(_couponApplied.data.pc_customized_data);
              let customized_data_value1;
              let customized_data_value2;
              let customized_data_value3;

              let found = 0;
              if(!Array.isArray(customized_data.course_bundle)) {
                if (cart[index].type == 'course')
                {
                  item_name = 'course_' + cart[index].id;
                } else if (cart[index].type == 'bundle') {
                  item_name = 'bundle_' + cart[index].id;
                }
                customized_data_value1 = customized_data.course_bundle;
                if (item_name in customized_data_value1) {
                  found = 1;
                }
              }

              if(!Array.isArray(customized_data.training_course)) {
                if (cart[index].type == 'booking_event')
                {
                  item_name = 'training_course_' + cart[index].course_id;
                } 
                customized_data_value2 = customized_data.training_course;
                if (item_name in customized_data_value2) {
                  found = 1;
                }
              }
              if(!Array.isArray(customized_data.training_events)) {
                if (cart[index].type == 'booking_event')
                {
                  item_name = 'training_event_' + cart[index].id;
                } 
                customized_data_value3 = customized_data.training_events;
                if (item_name in customized_data_value3) {
                  found = 1;
                }
              } 
              total_pre_cp_dis[index] = 0;
              let total_pre_cp_discount = 0;
                  // CUSTOM COUPON CALCULATION
              Object.keys(cart[index].learners).map((items) => {
                if(found) {
                  if(limit_discount_custom_coupon && limit_discount_custom_coupon > 0)
                  {   
                    if(_couponApplied.data.pc_coupon_option == 2) {
                      //For Membership
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          
                          let discount_price = Number(cart[index].others.member_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (discount_price > Number(_couponApplied.data.pc_maximum_discount))
                            {
                              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                              total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                            } else {
                              pre_cp_dis += discount_price;
                              total_pre_cp_discount += discount_price;
                            }
                          }
                          else
                          {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                          --limit_discount_custom_coupon;
                        
                      } else { //For Non-Membership
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (cart[index].others.discount_price > 0)
                            {
                              let discount_price = Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            } else {
                              let discount_price = Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            }
                          } else {
                            if (cart[index].others.discount_price > 0)
                            {
                                pre_cp_dis += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            } else {
                                pre_cp_dis += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            }
                          }
                          --limit_discount_custom_coupon;
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount
                    } else if(_couponApplied.data.pc_coupon_option == 1) {
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(cart[index].others.member_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (discount_price > Number(_couponApplied.data.pc_maximum_discount))
                            {
                              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                              total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                            } else {
                              pre_cp_dis += discount_price;
                              total_pre_cp_discount += discount_price;
                            }
                          }
                          else
                          {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                          total_pre_cp_dis[index] = total_pre_cp_discount;
                          --limit_discount_custom_coupon;
                          
                      } else {
                          pre_cp_dis += 0;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 0) {
                      if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (cart[index].others.discount_price > 0)
                            {
                              let discount_price = Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);

                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            } else {
                              let discount_price = Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            }
                          } else {
                            if (cart[index].others.discount_price > 0)
                            {
                                pre_cp_dis += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            } else {
                                pre_cp_dis += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            }
                          }
                          total_pre_cp_dis[index]=total_pre_cp_discount;
                          --limit_discount_custom_coupon;
                      } else {
                        pre_cp_dis += 0;
                      }
                    }
                    localStorage.setItem('limit_discount_custom_coupon', limit_discount_custom_coupon);
                  } else if (!is_coupon_limit_count_set) {
                    if(_couponApplied.data.pc_coupon_option == 2) {
                      //For Membership
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(cart[index].others.member_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (discount_price > Number(_couponApplied.data.pc_maximum_discount))
                            {
                              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                              total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                            } else {
                              pre_cp_dis += discount_price;
                              total_pre_cp_discount += discount_price;
                            }
                          }
                          else
                          {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }

                      } else { //For Non-Membership
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (cart[index].others.discount_price > 0)
                            {
                              let discount_price = Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            } else {
                              let discount_price = Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            }
                          } else {
                            if (cart[index].others.discount_price > 0)
                            {
                                pre_cp_dis += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            } else {
                                pre_cp_dis += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            }
                          }
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                    } else if(_couponApplied.data.pc_coupon_option == 1) {
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(cart[index].others.member_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (discount_price > Number(_couponApplied.data.pc_maximum_discount))
                            {
                              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                              total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                            } else {
                              pre_cp_dis += discount_price;
                              total_pre_cp_discount += discount_price;
                            }
                          }
                          else
                          {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                          total_pre_cp_dis[index] = total_pre_cp_discount;

                      } else {
                          pre_cp_dis += 0;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 0) {
                      if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (cart[index].others.discount_price > 0)
                            {
                              let discount_price = Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);

                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            } else {
                              let discount_price = Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            }
                          } else {
                            if (cart[index].others.discount_price > 0)
                            {
                                pre_cp_dis += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            } else {
                                pre_cp_dis += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            }
                          }
                          total_pre_cp_dis[index] = total_pre_cp_discount;
                      } else {
                        pre_cp_dis += 0;
                      }
                    }
                  }
                } else {
                  pre_cp_dis += 0;
                }
              });
            });
          } else {
            Object.keys(cart).map((index) => {
              total_pre_cp_dis[index] = 0;
              let total_pre_cp_discount = 0;

              if (Object.keys(cart[index].learners).length > 0) {
                Object.keys(cart[index].learners).map((items) => {
                  if(limit_discount_custom_coupon && limit_discount_custom_coupon > 0)
                  {   
                    if(_couponApplied.data.pc_coupon_option == 2) {
                      //For Membership
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          
                          let discount_price = Number(cart[index].others.member_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (discount_price > Number(_couponApplied.data.pc_maximum_discount))
                            {
                              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                              total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                            } else {
                              pre_cp_dis += discount_price;
                              total_pre_cp_discount += discount_price;
                            }
                          }
                          else
                          {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                          total_pre_cp_dis[index] = total_pre_cp_discount;
                          --limit_discount_custom_coupon;
                        
                      } else { //For Non-Membership
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (cart[index].others.discount_price > 0)
                            {
                              let discount_price = Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            } else {
                              let discount_price = Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            }
                          } else {
                            if (cart[index].others.discount_price > 0)
                            {
                                pre_cp_dis += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            } else {
                                pre_cp_dis += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            }
                          }
                          total_pre_cp_dis[index] = total_pre_cp_discount;
                          --limit_discount_custom_coupon;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 1) {
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(cart[index].others.member_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (discount_price > Number(_couponApplied.data.pc_maximum_discount))
                            {
                              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                              total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                            } else {
                              pre_cp_dis += discount_price;
                              total_pre_cp_discount += discount_price;
                            }
                          }
                          else
                          {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                          total_pre_cp_dis[index] = total_pre_cp_discount;
                          --limit_discount_custom_coupon;
                          
                      } else {
                          pre_cp_dis += 0;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 0) {
                      if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (cart[index].others.discount_price > 0)
                            {
                              let discount_price = Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);

                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            } else {
                              let discount_price = Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            }
                          } else {
                            if (cart[index].others.discount_price > 0)
                            {
                                pre_cp_dis += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            } else {
                                pre_cp_dis += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            }
                          }
                          total_pre_cp_dis[index] = total_pre_cp_discount;
                          --limit_discount_custom_coupon;
                      } else {
                        pre_cp_dis += 0;
                      }
                    }
                    localStorage.setItem('limit_discount_custom_coupon', limit_discount_custom_coupon);
                  } else if (!is_coupon_limit_count_set) {
                    if(_couponApplied.data.pc_coupon_option == 2) {
                      //For Membership
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(cart[index].others.member_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (discount_price > Number(_couponApplied.data.pc_maximum_discount))
                            {
                              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                              total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                            } else {
                              pre_cp_dis += discount_price;
                              total_pre_cp_discount += discount_price;
                            }
                          }
                          else
                          {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                      } else { //For Non-Membership
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (cart[index].others.discount_price > 0)
                            {
                              let discount_price = Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            } else {
                              let discount_price = Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            }
                          } else {
                            if (cart[index].others.discount_price > 0)
                            {
                                pre_cp_dis += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            } else {
                                pre_cp_dis += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            }
                          }
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                    } else if(_couponApplied.data.pc_coupon_option == 1) {
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(cart[index].others.member_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (discount_price > Number(_couponApplied.data.pc_maximum_discount))
                            {
                              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                              total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                            } else {
                              pre_cp_dis += discount_price;
                              total_pre_cp_discount += discount_price;
                            }
                          }
                          else
                          {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                      } else {
                          pre_cp_dis += 0;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 0) {
                      if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                          if (_couponApplied.data.pc_maximum_discount)
                          {
                            if (cart[index].others.discount_price > 0)
                            {
                              let discount_price = Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);

                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            } else {
                              let discount_price = Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                              if (discount_price > _couponApplied.data.pc_maximum_discount)
                              {
                                pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
                                total_pre_cp_discount += Number(_couponApplied.data.pc_maximum_discount);
                              } else {
                                pre_cp_dis += discount_price;
                                total_pre_cp_discount += discount_price;
                              }
                            }
                          } else {
                            if (cart[index].others.discount_price > 0)
                            {
                                pre_cp_dis += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.discount_price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            } else {
                                pre_cp_dis += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                                total_pre_cp_discount += Number(cart[index].others.price) * (Number(_couponApplied.data.pc_discount_rate) / 100);
                            }
                          }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                      } else {
                        pre_cp_dis += 0;
                      }
                    }
                  }
                })
              }
            });
          }
        } else {
          pre_cp_dis = 0;
        }
      } else {
        if(_couponApplied.data.pc_is_bulk_learner_price == 1) {
          let is_custom = (_couponApplied.data.pc_customized_data != "") ? 1 : 0;
          if(is_custom) {
            Object.keys(cart).map((index) => {
              let item_name = '';
              let customized_data = JSON.parse(_couponApplied.data.pc_customized_data);
              let customized_data_value1;
              let customized_data_value2;
              let customized_data_value3;

              let found = 0;
              if(!Array.isArray(customized_data.course_bundle)) {
                if (cart[index].type == 'course')
                {
                  item_name = 'course_' + cart[index].id;
                } else if (cart[index].type == 'bundle') {
                  item_name = 'bundle_' + cart[index].id;
                }
                customized_data_value1 = customized_data.course_bundle;
                if (item_name in customized_data_value1) {
                  found = 1;
                }
              }

              if(!Array.isArray(customized_data.training_course)) {
                if (cart[index].type == 'booking_event')
                {
                  item_name = 'training_course_' + cart[index].course_id;
                } 
                customized_data_value2 = customized_data.training_course;
                if (item_name in customized_data_value2) {
                  found = 1;
                }
              }
              if(!Array.isArray(customized_data.training_events)) {
                if (cart[index].type == 'booking_event')
                {
                  item_name = 'training_event_' + cart[index].id;
                } 
                customized_data_value3 = customized_data.training_events;
                if (item_name in customized_data_value3) {
                  found = 1;
                }
              } 
              total_pre_cp_dis[index] = 0;
              let total_pre_cp_discount = 0;
              // CUSTOM COUPON CALCULATION
              Object.keys(cart[index].learners).map((items) => {
                if(found) {
                  if(limit_discount_custom_coupon && limit_discount_custom_coupon > 0)
                  { 
                    if(_couponApplied.data.pc_coupon_option == 2) {
                      //For Membership
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(_couponApplied.data.pc_discount_rate);
                          if (discount_price > cart[index].others.member_price)
                          {
                            pre_cp_dis += Number(cart[index].others.member_price);
                            total_pre_cp_discount += Number(cart[index].others.member_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                      } else { //For Non-Membership
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (cart[index].others.discount_price > 0)
                        { 
                          if (discount_price > cart[index].others.discount_price)
                          {
                            pre_cp_dis += Number(cart[index].others.discount_price);
                            total_pre_cp_discount += Number(cart[index].others.discount_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        } else {
                          if (discount_price > cart[index].others.price)
                          {
                            pre_cp_dis += Number(cart[index].others.price);
                            total_pre_cp_discount += Number(cart[index].others.price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        }
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount
                      --limit_discount_custom_coupon;
                    } else if(_couponApplied.data.pc_coupon_option == 1) {
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (discount_price > cart[index].others.member_price)
                        {
                          pre_cp_dis += Number(cart[index].others.member_price);
                          total_pre_cp_discount += Number(cart[index].others.member_price);
                        } else {
                          pre_cp_dis += discount_price;
                          total_pre_cp_discount += discount_price;
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount
                        --limit_discount_custom_coupon;
                      } else {
                        pre_cp_dis += 0;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 0) {
                      if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (cart[index].others.discount_price > 0)
                        { 
                          if (discount_price > cart[index].others.discount_price)
                          {
                            pre_cp_dis += Number(cart[index].others.discount_price);
                            total_pre_cp_discount += Number(cart[index].others.discount_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        } else {
                          if (discount_price > cart[index].others.price)
                          {
                            pre_cp_dis += Number(cart[index].others.price);
                            total_pre_cp_discount += Number(cart[index].others.price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                        --limit_discount_custom_coupon;
                      } else {
                        pre_cp_dis += 0;
                      }
                    }
                    localStorage.setItem('limit_discount_custom_coupon', limit_discount_custom_coupon);
                  } else if (!is_coupon_limit_count_set) {
                    if(_couponApplied.data.pc_coupon_option == 2) {
                      //For Membership
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(_couponApplied.data.pc_discount_rate);
                          if (discount_price > cart[index].others.member_price)
                          {
                            pre_cp_dis += Number(cart[index].others.member_price);
                            total_pre_cp_discount += Number(cart[index].others.member_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                      } else { //For Non-Membership
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (cart[index].others.discount_price > 0)
                        { 
                          if (discount_price > cart[index].others.discount_price)
                          {
                            pre_cp_dis += Number(cart[index].others.discount_price);
                            total_pre_cp_discount += Number(cart[index].others.discount_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        } else {
                          if (discount_price > cart[index].others.price)
                          {
                            pre_cp_dis += Number(cart[index].others.price);
                            total_pre_cp_discount += Number(cart[index].others.price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        }
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                    } else if(_couponApplied.data.pc_coupon_option == 1) {
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (discount_price > cart[index].others.member_price)
                        {
                          pre_cp_dis += Number(cart[index].others.member_price);
                          total_pre_cp_discount += Number(cart[index].others.member_price);
                        } else {
                          pre_cp_dis += discount_price;
                          total_pre_cp_discount += discount_price;
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                      } else {
                        pre_cp_dis += 0;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 0) {
                      if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (cart[index].others.discount_price > 0)
                        { 
                          if (discount_price > cart[index].others.discount_price)
                          {
                            pre_cp_dis += Number(cart[index].others.discount_price);
                            total_pre_cp_discount += Number(cart[index].others.discount_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        } else {
                          if (discount_price > cart[index].others.price)
                          {
                            pre_cp_dis += Number(cart[index].others.price);
                            total_pre_cp_discount += Number(cart[index].others.price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                      } else {
                        pre_cp_dis += 0;
                      }
                    }
                  }
                } else {
                  pre_cp_dis += 0;
                }
              });
            });
          } else {
            Object.keys(cart).map((index) => {
              total_pre_cp_dis[index] = 0;
              let total_pre_cp_discount = 0;
              if (Object.keys(cart[index].learners).length > 0) {
                Object.keys(cart[index].learners).map((items) => {
                  if(limit_discount_custom_coupon && limit_discount_custom_coupon > 0)
                  { 
                    if(_couponApplied.data.pc_coupon_option == 2) {
                      //For Membership
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(_couponApplied.data.pc_discount_rate);
                          if (discount_price > cart[index].others.member_price)
                          {
                            pre_cp_dis += Number(cart[index].others.member_price);
                            total_pre_cp_discount += Number(cart[index].others.member_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                      } else { //For Non-Membership
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (cart[index].others.discount_price > 0)
                        { 
                          if (discount_price > cart[index].others.discount_price)
                          {
                            pre_cp_dis += Number(cart[index].others.discount_price);
                            total_pre_cp_discount += Number(cart[index].others.discount_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        } else {
                          if (discount_price > cart[index].others.price)
                          {
                            pre_cp_dis += Number(cart[index].others.price);
                            total_pre_cp_discount += Number(cart[index].others.price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        }
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                      --limit_discount_custom_coupon;
                    } else if(_couponApplied.data.pc_coupon_option == 1) {
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (discount_price > cart[index].others.member_price)
                        {
                          pre_cp_dis += Number(cart[index].others.member_price);
                          total_pre_cp_discount += Number(cart[index].others.member_price);
                        } else {
                          pre_cp_dis += discount_price;
                          total_pre_cp_discount += discount_price;
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                        --limit_discount_custom_coupon;
                      } else {
                        pre_cp_dis += 0;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 0) {
                      if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (cart[index].others.discount_price > 0)
                        { 
                          if (discount_price > cart[index].others.discount_price)
                          {
                            pre_cp_dis += Number(cart[index].others.discount_price);
                            total_pre_cp_discount += Number(cart[index].others.discount_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        } else {
                          if (discount_price > cart[index].others.price)
                          {
                            pre_cp_dis += Number(cart[index].others.price);
                            total_pre_cp_discount += Number(cart[index].others.price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                        --limit_discount_custom_coupon;
                      } else {
                        pre_cp_dis += 0;
                      }
                    }
                    localStorage.setItem('limit_discount_custom_coupon', limit_discount_custom_coupon);
                  } else if (!is_coupon_limit_count_set) {
                    if(_couponApplied.data.pc_coupon_option == 2) {
                      //For Membership
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                          let discount_price = Number(_couponApplied.data.pc_discount_rate);
                          if (discount_price > cart[index].others.member_price)
                          {
                            pre_cp_dis += Number(cart[index].others.member_price);
                            total_pre_cp_discount += Number(cart[index].others.member_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                      } else { //For Non-Membership
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (cart[index].others.discount_price > 0)
                        { 
                          if (discount_price > cart[index].others.discount_price)
                          {
                            pre_cp_dis += Number(cart[index].others.discount_price);
                            total_pre_cp_discount += Number(cart[index].others.discount_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        } else {
                          if (discount_price > cart[index].others.price)
                          {
                            pre_cp_dis += Number(cart[index].others.price);
                            total_pre_cp_discount += Number(cart[index].others.price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        }
                      }
                      total_pre_cp_dis[index] = total_pre_cp_discount;
                    } else if(_couponApplied.data.pc_coupon_option == 1) {
                      if (
                        cart[index].learners[items]['is_member'] == '1' &&
                        _showMember == '1' &&
                        cart[index].others.member_status == '1'
                      ) {
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (discount_price > cart[index].others.member_price)
                        {
                          pre_cp_dis += Number(cart[index].others.member_price);
                          total_pre_cp_discount += Number(cart[index].others.member_price);
                        } else {
                          pre_cp_dis += discount_price;
                          total_pre_cp_discount += discount_price;
                        }

                      total_pre_cp_dis[index] = total_pre_cp_discount;
                      } else {
                        pre_cp_dis += 0;
                      }
                    } else if(_couponApplied.data.pc_coupon_option == 0) {
                      if (!(cart[index].learners[items]['is_member'] == '1' && _showMember == '1' && cart[index].others.member_status == '1')) {
                        let discount_price = Number(_couponApplied.data.pc_discount_rate);
                        if (cart[index].others.discount_price > 0)
                        { 
                          if (discount_price > cart[index].others.discount_price)
                          {
                            pre_cp_dis += Number(cart[index].others.discount_price);
                            total_pre_cp_discount += Number(cart[index].others.discount_price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        } else {
                          if (discount_price > cart[index].others.price)
                          {
                            pre_cp_dis += Number(cart[index].others.price);
                            total_pre_cp_discount += Number(cart[index].others.price);
                          } else {
                            pre_cp_dis += discount_price;
                            total_pre_cp_discount += discount_price;
                          }
                        }
                        total_pre_cp_dis[index] = total_pre_cp_discount;
                      } else {
                        pre_cp_dis += 0;
                      }
                    }
                  }
                })
              }
            });
          }
        } else {
          pre_cp_dis = 0;
        }
      }
    }
    pre_cp_dis = pre_cp_dis > pre_total ? pre_total : pre_cp_dis;


    // FOR CUSTOMIZED DATA
    Object.keys(cart).map((cartkey) => {
      var cp_dis = 0;
      var dis = 0;
      var base_price = 0;
      var main_price = 0;
      var item_tax = 0;
      var item_tax_percent = 0;
      var price = 0;

      /*var qty =
        Object.keys(cart[cartkey].learners).length > 0
          ? Object.keys(cart[cartkey].learners).length
          : 1;*/

      if (Object.keys(cart[cartkey].learners).length > 0) {
        Object.keys(cart[cartkey].learners).map((items) => {
          if (
            cart[cartkey].learners[items]['is_member'] == '1' &&
            _showMember == '1' &&
            cart[cartkey].others.member_status == '1'
          ) {
            base_price += Number(cart[cartkey].others.member_price);
            main_price += Number(cart[cartkey].others.member_price);
          } else {
            base_price += Number(
              cart[cartkey].others.discount_price != '0'
                ? cart[cartkey].others.discount_price - cp_dis
                : cart[cartkey].others.price - cp_dis
            );
            main_price += Number(cart[cartkey].others.price);
          }
        });
      } else {
        Object.keys(cart).map((cont_index) => {
          if (
            cart[cont_index].others.member_status == '1' &&
            _validMember == '1'
          ) {
            base_price = Number(cart[cartkey].others.member_price);
            main_price = Number(cart[cartkey].others.member_price);
          } else {
            base_price = Number(
              cart[cartkey].others.discount_price != '0'
                ? cart[cartkey].others.discount_price - cp_dis
                : cart[cartkey].others.price - cp_dis
            );
            main_price = Number(cart[cartkey].others.price);
          }
        });
      }
      if (cart[cartkey].others.isfree == '1') {
        base_price = 0;
        main_price = 0;
      }

      if (_couponApplied.slug) {
        //case 1 custom coupon is applied
        if (
          _couponApplied.data.pc_customized_data &&
          _couponApplied.data.pc_coupon_type == 1
        ) {
          cp_dis = pre_cp_dis * cart[cartkey].contribution;
          dis =
            cart[cartkey].others.discount_price != '0'
              ? main_price - base_price
              : 0;
          // base_price			= cart[cartkey].others.base_price - cp_dis;
          item_tax_percent = cart[cartkey].others.taxes.total_tax;
          base_price = base_price - cp_dis;
          if (cart[cartkey].others.tax_method == '1') {
            item_tax =
              (this.getTotalPrice(cart[cartkey]) - this.getTotalPreCpDiscount(cart[cartkey],total_pre_cp_dis)) * (cart[cartkey].others.taxes.total_tax / 100);
          } else {
            item_tax = 0;
          }
          price = Number(this.getTotalPrice(cart[cartkey]) - this.getTotalPreCpDiscount(cart[cartkey],total_pre_cp_dis)) + Number(item_tax);
          // var pc_customized_data = _couponApplied.data.pc_customized_data.replace(new RegExp('training_event_', 'g'), 'booking_event_');
          // var testflag = false;
          // if (cart[cartkey].type == "booking_event") {
          // 	testflag = (pc_customized_data.search('training_course_' + cart[cartkey].course_id) != -1);
          // }
          // if (pc_customized_data.search(cartkey) != -1 || testflag) {
          // 	courseFound = 1;
          // 	// 0 percentage discount
          // 	// 1 amount discount
          // 	// base_price = (cart[cartkey].others.discount_price != '0') ? (cart[cartkey].others.discount_price - cp_dis) : (cart[cartkey].others.price - cp_dis);
          // 	// main_price = cart[cartkey].others.price;
          // 	if (_couponApplied.data.pc_discount_type == 0) {
          // 		cp_dis = base_price * (_couponApplied.data.pc_discount_rate / 100);
          // 		if (_couponApplied.data.pc_maximum_discount && cp_dis > _couponApplied.data.pc_maximum_discount) cp_dis = _couponApplied.data.pc_maximum_discount;

          // 	}
          // 	else {
          // 		cp_dis = (_couponApplied.data.pc_discount_rate >= base_price)?base_price:_couponApplied.data.pc_discount_rate;
          // 	}
          // 	dis = (cart[cartkey].others.discount_price != '0') ? (main_price - base_price) : 0;
          // 	item_tax_percent = cart[cartkey].others.taxes.total_tax;
          // 	base_price = base_price - cp_dis;
          // 	if (cart[cartkey].others.tax_method == '1') {
          // 		item_tax = base_price * (cart[cartkey].others.taxes.total_tax / 100);
          // 	}
          // 	else {

          // 		item_tax = 0;
          // 	}
          // 	price = Number(base_price) + Number(item_tax);
          // }
          // else {
          // 	cp_dis = 0;
          // 	// main_price = cart[cartkey].others.price;
          // 	// base_price = (cart[cartkey].others.discount_price != '0') ? (cart[cartkey].others.discount_price - cp_dis) : (cart[cartkey].others.price - cp_dis);
          // 	dis = (cart[cartkey].others.discount_price != '0') ? (main_price - base_price) : 0;
          // 	item_tax_percent = cart[cartkey].others.taxes.total_tax;
          // 	base_price = base_price - cp_dis;
          // 	if (cart[cartkey].others.tax_method == '1') {
          // 		item_tax = base_price * (cart[cartkey].others.taxes.total_tax / 100);
          // 	}
          // 	else {
          // 		item_tax = 0;
          // 	}
          // 	price = Number(base_price) + Number(item_tax);
          // }
          } else {
          ////case 2 -coupon is platform coupon then must deduct from corresponding courses the percentage or amount (amount issue since only once should be Deducted outside all)
          //flag here
          // base_price = (cart[cartkey].others.discount_price != '0') ? (cart[cartkey].others.discount_price) : (cart[cartkey].others.price);
          // main_price = cart[cartkey].others.price;
          cp_dis = pre_cp_dis * cart[cartkey].contribution;

          dis =
            cart[cartkey].others.discount_price != '0'
              ? main_price - base_price
              : 0;
          // base_price			= cart[cartkey].others.base_price - cp_dis;
          item_tax_percent = cart[cartkey].others.taxes.total_tax;
          base_price = base_price - cp_dis;
          if (cart[cartkey].others.tax_method == '1') {
            item_tax = 
              (this.getTotalPrice(cart[cartkey]) - this.getTotalPreCpDiscount(cart[cartkey],total_pre_cp_dis)) * (cart[cartkey].others.taxes.total_tax / 100);
          } else {
            item_tax = 0;
          }
          price = Number(this.getTotalPrice(cart[cartkey]) - this.getTotalPreCpDiscount(cart[cartkey],total_pre_cp_dis)) + Number(item_tax);
        }
      } else {
        cp_dis = 0;

        dis =
          cart[cartkey].others.discount_price != '0'
            ? main_price - base_price
            : 0;

        item_tax_percent = cart[cartkey].others.taxes.total_tax;
        base_price = base_price - cp_dis;
        if (cart[cartkey].others.tax_method == '1') {
          item_tax += (this.getTotalPrice(cart[cartkey]) - this.getTotalPreCpDiscount(cart[cartkey],total_pre_cp_dis)) * (cart[cartkey].others.taxes.total_tax / 100);
        } else {
          item_tax += 0;
        }
        price = Number(this.getTotalPrice(cart[cartkey]) - this.getTotalPreCpDiscount(cart[cartkey],total_pre_cp_dis)) + Number(item_tax);
      }
      // if(cart[cartkey].others.isfree)
      // {
      // 	main_price = 0;
      // 	base_price = 0;
      // 	item_tax = 0;
      // 	cp_dis = 0;
      // }
      tax_type = cart[cartkey].others.tax_method;

      total_main_price += Number(main_price);
      total_base_price += Number(base_price);
      total_tax += item_tax;
      total_tax_avg += item_tax_percent;
      total_dis += dis;

      
      total_cp_dis += Number(cp_dis);
      
      total_price += Number(price);
    });

    if (
      courseFound == 0 &&
      _couponApplied.slug &&
      _couponApplied.data.pc_coupon_type == 1
    ) {
      __invalidCoupon = true;
      this.removeCoupon();
    }
    if (total_cp_dis) {
      this.setState({ showpopup2: true });
    }

    // var _total = Math.round((total_price + Number.EPSILON) * 100) / 100;
    var _total = total_price;
    _total = _total < 0 ? 0 : _total;
    //checkprice
    this.props.refresh(total_items, _total, cart, 'app');
    if (pre_total < total_cp_dis) total_cp_dis = pre_total;

    return {
      base_total_price: total_base_price < 0 ? 0 : total_base_price,
      total_main_price: total_main_price < 0 ? 0 : total_main_price,
      tax_type: tax_type,
      total_tax: total_tax,
      total_cp_dis: total_cp_dis,
      total_dis: total_dis,
      total_price: total_price < 0 ? 0 : total_price,
    };
  };
/* replica of old checkout_calculations before coupon feature implmentation
   it is used because when bulk learner is disable cart shows wrong total price and
   coupon cannot be applied
*/
  checkoutCalculationsForBulkPurchaseDisable = (cart) => {
    var total_main_price = 0;
    var total_base_price = 0;
    var total_tax = 0;
    var tax_type = 0;
    var total_cp_dis = 0;
    var total_dis = 0;
    var total_price = 0;
    var total_tax_avg = 0;
    var courseFound = 0;

    var total_items = Object.keys(cart).length;
    var isflagset = 0;
    var pre_cp_dis = 0;
    var pre_total = 0;

    /* FOR DISCOUNT TYPE PERCENTAGE */
    Object.keys(cart).map((key) => {
      if (cart[key].others.discount_type && cart[key].others.discount_type == '1' && Number(cart[key].others.discount_percent) > 0) {
        cart[key].others.discount_price = Number(cart[key].others.price) - (Number(cart[key].others.discount_price))
      }
    })

    if (_couponApplied.slug && _couponApplied.data.pc_coupon_type == 0) {
      Object.keys(cart).map((index) => {
        if (Object.keys(cart[index].learners).length > 0) {
          Object.keys(cart[index].learners).map((items) => {
            if (
              cart[index].learners[items]['is_member'] == '1' &&
              _showMember == '1' &&
              cart[index].others.member_status == '1'
            ) {
              pre_total += Number(cart[index].others.member_price);
            } else {
              pre_total += Number(
                cart[index].others.discount_price != 0
                  ? cart[index].others.discount_price
                  : cart[index].others.price
              );
            }
          });
        } else {
          if (cart[index].others.member_status == '1' && _validMember == '1') {
            pre_total += Number(cart[index].others.member_price);
          } else {
            pre_total += Number(
              cart[index].others.discount_price != 0
                ? cart[index].others.discount_price
                : cart[index].others.price
            );
          }
        }
      });

      var tempContribution = 0;
      var tempTaxAmount = 0;
      var tempActualTaxAmount = 0;
      Object.keys(cart).map((cont_index) => {
        if (Object.keys(cart[cont_index].learners).length > 0) {
          tempContribution = 0;
          tempTaxAmount = 0;
          tempActualTaxAmount = 0;
          Object.keys(cart[cont_index].learners).map((items) => {
            if (
              cart[cont_index].learners[items]['is_member'] == '1' &&
              _showMember == '1' &&
              cart[cont_index].others.member_status == '1'
            ) {
              tempContribution += parseFloat(
                cart[cont_index].others.member_price
              );
              tempTaxAmount += parseFloat(
                cart[cont_index].others.member_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );
              tempActualTaxAmount += parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.member_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            } else {
              tempContribution += parseFloat(
                cart[cont_index].others.discount_price != 0
                  ? cart[cont_index].others.discount_price
                  : cart[cont_index].others.price
              );

              tempTaxAmount += parseFloat(
                cart[cont_index].others.base_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );

              tempActualTaxAmount += parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.base_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            }
          });
        } else {
          if (
            cart[cont_index].others.member_status == '1' &&
            _validMember == '1'
          ) {
            tempContribution = parseFloat(cart[cont_index].others.member_price);
            tempTaxAmount = parseFloat(
              cart[cont_index].others.member_price *
                (cart[cont_index].others.taxes.total_tax / 100)
            );
            tempActualTaxAmount = parseFloat(
              cart[cont_index].others.tax_method == '0'
                ? 0
                : cart[cont_index].others.member_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
            );
          } else {
            tempContribution = parseFloat(
              cart[cont_index].others.discount_price != 0
                ? cart[cont_index].others.discount_price
                : cart[cont_index].others.price
            );
            tempTaxAmount = parseFloat(
              cart[cont_index].others.base_price *
                (cart[cont_index].others.taxes.total_tax / 100)
            );
            tempActualTaxAmount = parseFloat(
              cart[cont_index].others.tax_method == '0'
                ? 0
                : cart[cont_index].others.base_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
            );
          }
        }
        cart[cont_index].contribution = parseFloat(
          pre_total > 0 ? tempContribution / pre_total : tempContribution
        );
        cart[cont_index].tax_amount = tempTaxAmount;
        cart[cont_index].actual_tax_amount = tempActualTaxAmount;
      });
      
      Object.keys(cart).map((cont_index) => {
        if (_couponApplied.data.pc_discount_type == 0) {
          let item_amt_price; 
          if (cart[cont_index].others.member_status == '1' && _validMember == '1') {
            item_amt_price = Number(cart[cont_index].others.member_price);
          } else {
            item_amt_price = Number(cart[cont_index].others.discount_price != 0 ? cart[cont_index].others.discount_price : cart[cont_index].others.price);
          }
          let temp_cp_dis = item_amt_price * (_couponApplied.data.pc_discount_rate / 100);
          if (_couponApplied.data.pc_maximum_discount && temp_cp_dis > _couponApplied.data.pc_maximum_discount)
          {
              pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
          } else {
              pre_cp_dis += Number(temp_cp_dis);
          }
        } else {
          pre_cp_dis += Number(_couponApplied.data.pc_discount_rate);
        }
      });
    } else if (
      _couponApplied.data &&
      _couponApplied.data.pc_customized_data &&
      _couponApplied.data.pc_coupon_type == 1
    ) {
      var pc_customized_data = _couponApplied.data.pc_customized_data.replace(
        new RegExp('training_event_', 'g'),
        'booking_event_'
      );

      Object.keys(cart).map((index) => {
        var testflag = false;
        if (cart[index].type == 'booking_event') {
          testflag =
            pc_customized_data.search(
              'training_course_' + cart[index].course_id
            ) != -1;
        }
        if (pc_customized_data.search(index) != -1 || testflag) {
          courseFound = 1;
          if (Object.keys(cart[index].learners).length > 0) {
            Object.keys(cart[index].learners).map((items) => {
              if (
                cart[index].learners[items]['is_member'] == '1' &&
                _showMember == '1' &&
                cart[index].others.member_status == '1'
              ) {
                pre_total += Number(cart[index].others.member_price);
              } else {
                pre_total += Number(
                  cart[index].others.discount_price != 0
                    ? cart[index].others.discount_price
                    : cart[index].others.price
                );
              }
            });
          } else {
            if (
              cart[index].others.member_status == '1' &&
              _validMember == '1'
            ) {
              pre_total += Number(cart[index].others.member_price);
            } else {
              pre_total += Number(
                cart[index].others.discount_price != 0
                  ? cart[index].others.discount_price
                  : cart[index].others.price
              );
            }
          }
        }
      });

      var tempContribution = 0;
      var tempTaxAmount = 0;
      var tempActualTaxAmount = 0;

      Object.keys(cart).map((cont_index) => {
        var testflag = false;
        if (cart[cont_index].type == 'booking_event') {
          testflag =
            pc_customized_data.search(
              'training_course_' + cart[cont_index].course_id
            ) != -1;
        }
        if (pc_customized_data.search(cont_index) != -1 || testflag) {
          courseFound = 1;
          tempContribution = 0;
          tempTaxAmount = 0;
          tempActualTaxAmount = 0;
          if (Object.keys(cart[cont_index].learners).length > 0) {
            Object.keys(cart[cont_index].learners).map((items) => {
              if (
                cart[cont_index].learners[items]['is_member'] == '1' &&
                _showMember == '1' &&
                cart[cont_index].others.member_status == '1'
              ) {
                tempContribution += parseFloat(
                  cart[cont_index].others.member_price
                );
                tempTaxAmount += parseFloat(
                  cart[cont_index].others.member_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
                );
                tempActualTaxAmount += parseFloat(
                  cart[cont_index].others.tax_method == '0'
                    ? 0
                    : cart[cont_index].others.member_price *
                        (cart[cont_index].others.taxes.total_tax / 100)
                );
              } else {
                tempContribution += parseFloat(
                  cart[cont_index].others.discount_price != 0
                    ? cart[cont_index].others.discount_price
                    : cart[cont_index].others.price
                );

                tempTaxAmount += parseFloat(
                  cart[cont_index].others.base_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
                );

                tempActualTaxAmount += parseFloat(
                  cart[cont_index].others.tax_method == '0'
                    ? 0
                    : cart[cont_index].others.base_price *
                        (cart[cont_index].others.taxes.total_tax / 100)
                );
              }
            });
          } else {
            if (
              cart[cont_index].others.member_status == '1' &&
              _validMember == '1'
            ) {
              tempContribution = parseFloat(
                cart[cont_index].others.member_price
              );
              tempTaxAmount = parseFloat(
                cart[cont_index].others.member_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );
              tempActualTaxAmount = parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.member_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            } else {
              tempContribution = parseFloat(
                cart[cont_index].others.discount_price != 0
                  ? cart[cont_index].others.discount_price
                  : cart[cont_index].others.price
              );

              tempTaxAmount = parseFloat(
                cart[cont_index].others.base_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );

              tempActualTaxAmount = parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.base_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            }
          }
          cart[cont_index].contribution = parseFloat(
            pre_total > 0 ? tempContribution / pre_total : tempContribution
          );
          cart[cont_index].tax_amount = tempTaxAmount;
          cart[cont_index].actual_tax_amount = tempActualTaxAmount;
        } else {
          tempContribution = 0;
          tempTaxAmount = 0;
          tempActualTaxAmount = 0;
          if (Object.keys(cart[cont_index].learners).length > 0) {
            Object.keys(cart[cont_index].learners).map((items) => {
              if (
                cart[cont_index].learners[items]['is_member'] == '1' &&
                _showMember == '1' &&
                cart[cont_index].others.member_status == '1'
              ) {
                tempContribution += 0;
                tempTaxAmount += parseFloat(
                  cart[cont_index].others.member_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
                );
                tempActualTaxAmount += parseFloat(
                  cart[cont_index].others.tax_method == '0'
                    ? 0
                    : cart[cont_index].others.member_price *
                        (cart[cont_index].others.taxes.total_tax / 100)
                );
              } else {
                tempContribution += 0;
                tempTaxAmount += parseFloat(
                  cart[cont_index].others.base_price *
                    (cart[cont_index].others.taxes.total_tax / 100)
                );
                tempActualTaxAmount += parseFloat(
                  cart[cont_index].others.tax_method == '0'
                    ? 0
                    : cart[cont_index].others.base_price *
                        (cart[cont_index].others.taxes.total_tax / 100)
                );
              }
            });
          } else {
            if (
              cart[cont_index].others.member_status == '1' &&
              _validMember == '1'
            ) {
              tempContribution = 0;
              tempTaxAmount = parseFloat(
                cart[cont_index].others.member_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );
              tempActualTaxAmount = parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.member_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            } else {
              tempContribution = 0;
              tempTaxAmount = parseFloat(
                cart[cont_index].others.base_price *
                  (cart[cont_index].others.taxes.total_tax / 100)
              );
              tempActualTaxAmount = parseFloat(
                cart[cont_index].others.tax_method == '0'
                  ? 0
                  : cart[cont_index].others.base_price *
                      (cart[cont_index].others.taxes.total_tax / 100)
              );
            }
          }
          cart[cont_index].contribution = parseFloat(
            pre_total > 0 ? tempContribution / pre_total : tempContribution
          );
          cart[cont_index].tax_amount = tempTaxAmount;
          cart[cont_index].actual_tax_amount = tempActualTaxAmount;
        }
      });

      Object.keys(cart).map((cont_index) => {
        if (_couponApplied.data.pc_discount_type == 0) {
          let item_amt_price; 
          if (cart[cont_index].others.member_status == '1' && _validMember == '1') {
            item_amt_price = Number(cart[cont_index].others.member_price);
          } else {
            item_amt_price = Number(cart[cont_index].others.discount_price != 0 ? cart[cont_index].others.discount_price : cart[cont_index].others.price);
          }
          let temp_cp_dis = item_amt_price * (_couponApplied.data.pc_discount_rate / 100);
          if (_couponApplied.data.pc_maximum_discount && temp_cp_dis > _couponApplied.data.pc_maximum_discount)
          {
            pre_cp_dis += Number(_couponApplied.data.pc_maximum_discount);
          } else {
            pre_cp_dis += temp_cp_dis;
          }
        } else {
          pre_cp_dis += Number(_couponApplied.data.pc_discount_rate);
        }
      });
    }
    pre_cp_dis = pre_cp_dis > pre_total ? pre_total : pre_cp_dis;

    Object.keys(cart).map((cartkey) => {
      var cp_dis = 0;
      var dis = 0;
      var base_price = 0;
      var main_price = 0;
      var item_tax = 0;
      var item_tax_percent = 0;
      var price = 0;

      if (Object.keys(cart[cartkey].learners).length > 0) {
        Object.keys(cart[cartkey].learners).map((items) => {
          if (
            cart[cartkey].learners[items]['is_member'] == '1' &&
            _showMember == '1' &&
            cart[cartkey].others.member_status == '1'
          ) {
            base_price += Number(cart[cartkey].others.member_price);
            main_price += Number(cart[cartkey].others.member_price);
          } else {
            base_price += Number(
              cart[cartkey].others.discount_price != '0'
                ? cart[cartkey].others.discount_price - cp_dis
                : cart[cartkey].others.price - cp_dis
            );
            main_price += Number(cart[cartkey].others.price);
          }
        });
      } else {
        Object.keys(cart).map((cont_index) => {
          if (
            cart[cont_index].others.member_status == '1' &&
            _validMember == '1'
          ) {
            base_price = Number(cart[cartkey].others.member_price);
            main_price = Number(cart[cartkey].others.member_price);
          } else {
            base_price = Number(
              cart[cartkey].others.discount_price != '0'
                ? cart[cartkey].others.discount_price - cp_dis
                : cart[cartkey].others.price - cp_dis
            );
            main_price = Number(cart[cartkey].others.price);
          }
        });
      }
      if (cart[cartkey].others.isfree == '1') {
        base_price = 0;
        main_price = 0;
      }
     
      if (_couponApplied.slug) {
        let item_amt_price; 
        if (cart[cartkey].others.member_status == '1' && _validMember == '1') {
          item_amt_price = Number(cart[cartkey].others.member_price);
        } else {
          item_amt_price = Number(cart[cartkey].others.discount_price != 0 ? cart[cartkey].others.discount_price : cart[cartkey].others.price);
        }
        if (_couponApplied.data.pc_discount_type == 0) {
          let temp_cp_dis = item_amt_price * (_couponApplied.data.pc_discount_rate / 100);
          if (_couponApplied.data.pc_maximum_discount && temp_cp_dis > _couponApplied.data.pc_maximum_discount)
          {
            cp_dis = Number(_couponApplied.data.pc_maximum_discount);
          } else {
            cp_dis = Number(temp_cp_dis);
          }
        } else {
          cp_dis = Number(_couponApplied.data.pc_discount_rate) > item_amt_price ? item_amt_price : Number(_couponApplied.data.pc_discount_rate);
        }

        if (
          _couponApplied.data.pc_customized_data &&
          _couponApplied.data.pc_coupon_type == 1
        ) {
          let customizedFoundFlag = false;
          if (cart[cartkey].type == 'booking_event') {
            customizedFoundFlag =
              pc_customized_data.search(
                'training_course_' + cart[cartkey].course_id
              ) != -1;
          }
          cp_dis = (pc_customized_data.search(cartkey) != -1 || customizedFoundFlag) ? cp_dis : 0;
          dis =
            cart[cartkey].others.discount_price != '0'
              ? main_price - base_price
              : 0;
          
          item_tax_percent = cart[cartkey].others.taxes.total_tax;
          base_price = base_price - cp_dis;
          if (cart[cartkey].others.tax_method == '1') {
            item_tax =
              base_price * (cart[cartkey].others.taxes.total_tax / 100);
          } else {
            item_tax = 0;
          }
          price = Number(base_price) + Number(item_tax);
          
        } else {
          ////case 2 -coupon is platform coupon then must deduct from corresponding courses the percentage or amount (amount issue since only once should be Deducted outside all)
          //flag here
          // base_price = (cart[cartkey].others.discount_price != '0') ? (cart[cartkey].others.discount_price) : (cart[cartkey].others.price);
          // main_price = cart[cartkey].others.price;
          // cp_dis = pre_cp_dis * cart[cartkey].contribution;
          dis =
            cart[cartkey].others.discount_price != '0'
              ? main_price - base_price
              : 0;
          
          item_tax_percent = cart[cartkey].others.taxes.total_tax;
          base_price = base_price - cp_dis;
          if (cart[cartkey].others.tax_method == '1') {
            item_tax =
              base_price * (cart[cartkey].others.taxes.total_tax / 100);
          } else {
            item_tax = 0;
          }
          price = Number(base_price) + Number(item_tax);
        }
      } else {
        cp_dis = 0;
        dis =
          cart[cartkey].others.discount_price != '0'
            ? main_price - base_price
            : 0;
       
        item_tax_percent = cart[cartkey].others.taxes.total_tax;
        base_price = base_price - cp_dis;
        if (cart[cartkey].others.tax_method == '1') {
          item_tax = base_price * (cart[cartkey].others.taxes.total_tax / 100);
        } else {
          item_tax = 0;
        }
        price = Number(base_price) + Number(item_tax);
      }
    
      tax_type = cart[cartkey].others.tax_method;

      total_main_price += Number(main_price);
      total_base_price += Number(base_price);
      total_tax += item_tax;
      total_tax_avg += item_tax_percent;
      total_dis += dis;
      total_cp_dis += Number(cp_dis);
      total_price += Number(price);

    });

    if (
      courseFound == 0 &&
      _couponApplied.slug &&
      _couponApplied.data.pc_coupon_type == 1
    ) {
      __invalidCoupon = true;
     
      this.removeCoupon();
    }
    if (total_cp_dis) {
      this.setState({ showpopup2: true });
    }

    var _total = Math.round((total_price + Number.EPSILON) * 100) / 100;
    _total = _total < 0 ? 0 : _total;
    //checkprice
    this.props.refresh(total_items, _total, cart, 'app');

    if (pre_total < total_cp_dis) total_cp_dis = pre_total;

    return {
      base_total_price: total_base_price < 0 ? 0 : total_base_price,
      total_main_price: total_main_price < 0 ? 0 : total_main_price,
      tax_type: tax_type,
      total_tax: total_tax,
      total_cp_dis: total_cp_dis,
      total_dis: total_dis,
      total_price: total_price < 0 ? 0 : total_price,
    };
  };

  /* FOR PACKAGE CHECKOUT CALCULATION */
  checkoutCalculationsForPackage = (cart) => {
    let base_price       = 0;
    let main_price       = 0;
    let total_main_price = 0;
    let total_base_price = 0;
    let item_tax         = 0;
    let total_tax        = 0;
    let tax_type         = 0;
    let total_cp_dis     = 0;
    let total_dis        = 0;
    let total_price      = 0;
    let total_tax_avg    = 0;
    let _total           = 0;
    
    let total_items      = Object.keys(cart).length;
    let pre_total        = 0;
    let dis              = 0;
    let cp_dis           = 0;
    let price            = 0;
    let index            = Object.keys(cart);
    
    if (total_items)
    {
      Object.keys(cart).map((cartkey) => {

        // _bfo DISABLE CONDITION
        if (_bfo == 0) {
          
          pre_total  += (cart[cartkey].others.discount_type && Number(cart[cartkey].others.discount_percent) > 0) ?
                        Number(cart[cartkey].others.price) - (Number(cart[cartkey].others.price) * Number(cart[cartkey].others.discount_percent)/100) :
                        Number(
                          cart[cartkey].others.discount_price != 0
                            ? cart[cartkey].others.discount_price
                            : cart[cartkey].others.price
                        );
          base_price += Number(pre_total);
          main_price += Number(cart[cartkey].others.price);

          if (cart[cartkey].others.tax_method == '1') {
            item_tax += Number(base_price * (cart[cartkey].others.taxes.total_tax / 100));
          } else {
            item_tax += 0;
          }

        } else {
          let learnerData = cartService.getLearner(cartkey);
          if (Object.keys(cart[cartkey].learners).length > 0)
          {
            let learners = Object.keys(cart[cartkey].learners).length; 
            Object.keys(cart[cartkey].learners).map((key) => {

              if (
                cart[cartkey].learners[key]['is_member'] == '1' &&
                _showMember == '1' &&
                cart[cartkey].others.member_status == '1'
              ) {
                pre_total = Number(cart[cartkey].others.member_price);
              } else { 
                  pre_total = (cart[cartkey].others.discount_type && Number(cart[cartkey].others.discount_percent) > 0) ?
                              Number(cart[cartkey].others.price) - (Number(cart[cartkey].others.price) * Number(cart[cartkey].others.discount_percent)/100) :
                              Number(
                                cart[cartkey].others.discount_price != 0
                                  ? cart[cartkey].others.discount_price
                                  : cart[cartkey].others.price
                              );
                
              }
              
              base_price         += Number(pre_total);
              if (cart[cartkey].learners[key]['is_member'] == '1' && _showMember == '1' &&cart[cartkey].others.member_status == '1') 
              {
                main_price       += Number(cart[cartkey].others.member_price);
              } else {
                main_price       += Number(cart[cartkey].others.price);
              }
            })
            
          } else {
            /* new package */
            pre_total  = Number(
                          cart[cartkey].others.discount_price != 0
                            ? cart[cartkey].others.discount_price
                            : cart[cartkey].others.price);

            base_price += Number(pre_total);
            main_price += Number(cart[cartkey].others.price);
            /* new package */
          }
          if (cart[cartkey].others.tax_method == '1') {
            item_tax += (base_price * (cart[cartkey].others.taxes.total_tax / 100));
          } else {
            item_tax += 0;
          }
        }

        if (cart[cartkey].others.isfree == '1') {
          base_price = 0;
          main_price = 0;
        }

        price = Number(base_price) + Number(item_tax);


        tax_type = cart[cartkey].others.tax_method;

        total_main_price = Number(main_price);
        total_base_price = Number(base_price);
        total_tax = item_tax;
        total_tax_avg = cart[cartkey].others.taxes.total_tax;
        total_dis = Number(main_price) - Number(base_price);
        total_cp_dis = Number(cp_dis);
        total_price = Number(price);
  
      })

      _total = total_price;
      _total = _total < 0 ? 0 : _total;
      //checkprice
      this.props.refresh(total_items, _total, cart, 'app');
      if (pre_total < total_cp_dis) total_cp_dis = pre_total;

      return {
        base_total_price: total_base_price < 0 ? 0 : total_base_price,
        total_main_price: total_main_price < 0 ? 0 : total_main_price,
        tax_type: tax_type,
        total_tax: total_tax,
        total_cp_dis: total_cp_dis,
        total_dis: total_dis,
        total_price: total_price < 0 ? 0 : total_price,
      };
    }
  }

  removePackage = () => {
    this.setState({packagePopup: false});
  }
  /* FOR PACKAGE CHECKOUT CALCULATION */

  getTotalPrice = (cart) => {
    let total_price_calc = 0;
      if (Object.keys(cart.learners).length > 0) {
        Object.keys(cart.learners).map((items) => {
          if (
            cart.learners[items]['is_member'] == '1' &&
            _showMember == '1' &&
            cart.others.member_status == '1'
          ) {
            total_price_calc += Number(cart.others.member_price);
          } else {
            total_price_calc += Number(
              cart.others.discount_price != '0'
                ? cart.others.discount_price
                : cart.others.price
            );
          }
        });
      } else {
        total_price_calc = Number(
          cart.others.discount_price != '0'
            ? cart.others.discount_price
            : cart.others.price
        );
      }
    return total_price_calc;
  }

  getTotalPreCpDiscount = (cart, discount) => {
    let cart_index = cart.type + '_'+ cart.id;
    if (cart_index in discount) {
      return discount[cart_index];
    }
    return 0;
  }

  showCoupons = () => {
    this.setState({
      showpopup: true,
      // couponApplied:true
    });
  };
  removeCoupon = () => {
    _couponApplied.slug = '';
    _couponApplied.code = '';
    _couponApplied.data = null;
    this.setState({
      couponApplied: false,
    });
    this.props.couponappliedtrigger();
  
    // ON REMOVE COUPON REMOVE SPECIFIC KEY ADDED ON LEARNER FROM LOCALSTORAGE
    const change_cart = JSON.parse(localStorage.getItem('mycart'));

    Object.keys(change_cart).map((item) => {
      var learner = change_cart[item]['learners'];
      
      Object.keys(learner).map((index) => {
        if (learner[index].discount_price)
        {
          delete learner[index].is_bulk_learner_discount;
          delete learner[index].discount_price;
          delete learner[index].total_after_discount;
          localStorage.setItem('mycart', JSON.stringify(change_cart));
        }
      })
    })

    

    // ON REMOVE COUPON REMOVE FROM COUPON LIMIT LOCALSTORAGE
    const removeCouponLimit = localStorage.getItem('coupon_limit_usage');
    if (removeCouponLimit || (typeof removeCouponLimit == 'undefined')) {
      localStorage.removeItem("coupon_limit_usage");
    }

    const removeCouponLimitRemain = localStorage.getItem('limit_remaining_coupon');
    if (removeCouponLimitRemain || (typeof removeCouponLimitRemain == 'undefined')) {
      localStorage.removeItem("limit_remaining_coupon");
    }

    const removeCouponDiscountLimitRemain = localStorage.getItem('limit_discount_remaining_coupon');
    if (removeCouponDiscountLimitRemain || (typeof removeCouponDiscountLimitRemain == 'undefined')) {
      localStorage.removeItem("limit_discount_remaining_coupon");
    }

    const removeCouponDiscountCustomRemain = localStorage.getItem('limit_discount_custom_coupon');
    if (removeCouponDiscountCustomRemain || (typeof removeCouponDiscountCustomRemain == 'undefined')) {
      localStorage.removeItem("limit_discount_custom_coupon");
    }

    const removeCouponLimitLearner = localStorage.getItem('coupon_limit_learner_usage');
    if (removeCouponLimitLearner || (typeof removeCouponLimitLearner == 'undefined')) {
      localStorage.removeItem("coupon_limit_learner_usage");
    }
    
    
  };

  applyCoupon = () => {
    this.props.couponappliedtrigger();
    this.setState({
      showpopup: false,
      couponApplied:true
    });
  };
  
  removeCouponAppliedpopup = () => {
    this.setState({
      showpopup2: false
      // couponApplied:true
    });
  };

  ReviewedCartContinueCallBack = () => {
    this.checkOut(false);
  };

  validiateCartApi = async (postData) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(postData),
    };
    const response = await fetch(`${siteUrl}cart_react`, requestOptions);
    const data = await response.json();
    return data;
  };

  checkOut = async (dc_form = null) => {
    // let showCartItemValidateModal = validateItems;
    // let expiredCartItems = [];
    let cartData = cartService.getCart();

    // on empty cart reload
    if (!cartData) {
      location.reload();
    }

    if (_buyNow) {
      let index = _buyNowDetails.type + '_' + _buyNowDetails.id;
      let cart = {};
      cart[index] = _buyNowDetails;
      cartData = cart;
    }
    // if (validateItems) {
    // }
    let pcCode =
      _couponApplied.data != undefined &&
      _couponApplied.data.pc_code != undefined
        ? _couponApplied.data.pc_code
        : '';
    let payload_data = {
      coupon_code: pcCode,
      isbuynow: _buyNow,
      user: dc_form ? dc_form : null,
      items: cartData,
      bfo: _bfo,
      address: localStorage.myaddress && _bfo ? localStorage.myaddress : null,
    };

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload_data),
    };
    const response = await fetch(
      `${siteUrl}cart_react/validate_checkout`,
      requestOptions
    );
    const data = await response.json();

    if (data.refresh) {
      window.location.href = siteUrl + 'cart_react';
    }

    // validation popups
    if (data.error) {
      this.setState({
        showCheckOutValidateModal: true,
        showCheckOutValidateModalData: data,
      });
      return false;
    }

    if (Number(window.userEmailVerified) != Number('1') && __isLoggedin) {
      // for email verigication popups
      this.setState({
        showEmilVerifyModal: true,
        showCartItemValidateModal: false,
      });
      return false;
    }
    if (cartService.showDetailCollectionPop() && !dc_form) {
      //pps form
      this.setState({
        showPpsModal: true,
        showCartItemValidateModal: false,
      });
      return false;
    }

    if (Number(window.userEmailVerified) != Number('1') && __isLoggedin) {
      // for email verigication popups
      this.setState({
        showPpsModal: false,
        showEmilVerifyModal: true,
        showCartItemValidateModal: false,
      });
      return false;
    }
    
    // LIMIT DISCOUNT
    let pcId =
      _couponApplied.data != undefined &&
      _couponApplied.data.id != undefined
        ? _couponApplied.data.id
        : '';
    
    var checkCouponUsed = 0;
    if (pcId) {
      CartService.getCouponRemaining(pcId).then((res) => {
        this.setState({
          checkoutStateLast: res.coupon_remaining
        });
  
        Object.keys(cartData).map((index) => {
          Object.keys(cartData[index].learners).map((list) => {
            if (cartData[index].learners[list].total_after_discount > 0) 
            {
              ++checkCouponUsed;
            }
          })
        })
  
        if (checkCouponUsed && checkCouponUsed > res.coupon_remaining)
        {
          this.setState({
            couponNotAllowed: true
          })
        } else {
          this.submitForm({ user: dc_form });
        }
      });
    } else {
      this.submitForm({ user: dc_form });
    }
    
    /*
    try {
      // var courseMemberStatus = 0;
      // if (typeof cart[index]['others']['member_status'] === 'undefined') {
      //   courseMemberStatus = '0';
      // } else {
      //   courseMemberStatus = cart[index]['others']['member_status'];
      // }
      var res = await fetch(api_url + '/validate_membership', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data
          ? JSON.stringify({
              dc_form: dc_form,
              coursestatus: 1,
              validType: 0,
            })
          : '{}',
      });
      var ismemberdata = await res.json();
    } catch (error) {
    }
    this.setState({
      memberPopup: true,
    });
    setTimeout(() => {
      // this.submitForm({ user: dc_form });
    }, 5500);
*/
    // this.submitForm({ user: dc_form });
  };
  dissmissmodal_membermsg = () => {
    this.setState({
      memberPopup: false,
    });
  };

  callBackEmailVerifySkip = () => {
    if (this.props.data.ppsRequired) {
      this.setState({
        showEmilVerifyModal: false,
        showPpsModal: true,
        showCartItemValidateModal: false,
      });
    } else {
      this.submitForm();
    }
  };
  callBackEamilVerify = () => {};

  checkOutProccessCall = (ppsData = false) => {
    let cartData = cartService.getCart();
    const res = this.postFormDataAsJson(siteUrl + 'cart_react/store', {
      formData: ppsData,
      cartData,
    });
  };

  ppsSkipCheckOutProccessCall = () => {
    if (_buyNow) {
      window.location.href =
        siteUrl +
        'cart_react/store?item=' +
        _buyNow +
        '&coupon=' +
        _couponApplied.slug
          ? _couponApplied.slug
          : '';
    }
    // else{
    // 	window.location.href=siteUrl+'cart_react/store?apiresponse=1'+'&coupon='+(_couponApplied.slug)?_couponApplied.slug:'';
    // }
  };

  postFormDataAsJson = async (apiCall, formData) => {
    const formDataJsonString = JSON.stringify(formData);

    const fetchOptions = {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },

      body: formDataJsonString,
    };

    const response = await fetch(apiCall, fetchOptions);
    return await response.json();
  };


// Function to delete localStorage items with valid email keys and key containing country_code_
deleteItemsWithValidEmailKeys = () =>{
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (emailRegex.test(key)) {
      // Delete the localStorage item
      localStorage.removeItem(key);
    }
    if(key.includes("country_code_"))
    {
      localStorage.removeItem(key);
    }
  }
}

  submitForm = (params = {}) => {
    // variables
    params['coupon'] = _couponApplied.slug;
    params['billing'] = localStorage.myaddress ? localStorage.myaddress : '[]';
    params['cart'] = localStorage.mycart ? localStorage.mycart : '[]';
    if(__isLoggedin) {
      CartService.updateCartDetails(params['cart']).then((resp) => {
        console.log(resp);
      }).catch((err) => {
        console.log(err);
      });
    }
    // params['user'] = (dc_form) ? dc_form : '[]'; //sending form parent function
    if (_buyNow) params['buynow'] = _buyNow;
    if (_buyNow) params['buynowdetails'] = JSON.stringify(_buyNowDetails);

    const cart = JSON.parse(localStorage.mycart || '{}');
    const cartId = Object.keys(cart)[0];
    if (cart[cartId]?.waitingList && Object.keys(cart[cartId].waitingList).length > 0) {
      const learners = JSON.stringify(cart[cartId].waitingList);
      const data = {
          learners: learners,
          booking_status: 2,
          buynow: `${cartId}`,
          user: params['billing'],
          is_bulk_enroll: true,
          is_waiting_list: true,
          cart: params['cart']
      };

      function serialize(data) {
          const params = new URLSearchParams();
          for (const key in data) {
              if (data.hasOwnProperty(key)) {
                  params.append(key, data[key]);
              }
          }
          return params.toString();
      }

      fetch(`${siteUrl}cart_react/store?buynow=${cartId}&api=true`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: serialize(data),
      })
      .then((response) => response.json())
      .then((data) => {
          console.log('Success:', data);
      })
      .catch((error) => {
          console.log('Error:', error);
      });
  }


    const form = document.createElement('form');
    form.method = 'POST';
    form.action = siteUrl + 'cart_react/store';

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];

        form.appendChild(hiddenField);
      }
    }

    document.body.appendChild(form);
    localStorage.mycart_count = 0;
    localStorage.mycart = '{}';
    this.deleteItemsWithValidEmailKeys();
    form.submit();
  };

  PpsModalClose = () => {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.setState({ showPpsModal: !this.state.showPpsModal });
  };
  EmailVerifyModalClose = () => {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.setState({ showEmilVerifyModal: !this.state.showEmilVerifyModal });
  };

  // REVERSE PROP FROM COUPONMODEL TO CHECKOUT
  updatingCheckoutState = (param) => {
    this.state = {
      appUpdateState: param
    };
    this.props.updateAppState(this.state.appUpdateState);
  }
  // REVERSE PROP FROM COUPONMODEL TO CHECKOUT

  /*
  * FUNCTION findLearnerInCustomizedCartItems AND findLearnerInCustomizedCartItemsLearners
  * FIND TOTAL MEMBER AND NON LEARNER IN CUSTOMIZED CART ITEMS
  */
  findLearnerInCustomizedCartItems = (customized_datas, cart_index_with_learner) => {
    let set_learners = {
      total : 0,
      member : 0,
      non_member : 0
    };
    //FOR COURSE AND BUNDLE
    if (!Array.isArray(customized_datas.course_bundle))
    {
      let course_bundle = customized_datas.course_bundle;
      set_learners = this.findLearnerInCustomizedCartItemsLearners('course_bundle',course_bundle, cart_index_with_learner, set_learners)
    }
    if (!Array.isArray(customized_datas.training_course))
    {
      let training_course = customized_datas.training_course;
      set_learners = this.findLearnerInCustomizedCartItemsLearners('training_course',training_course, cart_index_with_learner, set_learners)
    }
    if (!Array.isArray(customized_datas.training_events))
    {
      let training_events = customized_datas.training_events;
      set_learners = this.findLearnerInCustomizedCartItemsLearners('training_event',training_events, cart_index_with_learner, set_learners)
    }
    return set_learners;
  }

  findLearnerInCustomizedCartItemsLearners = (key, customized_data,cart_index_with_learner, set_learners) => {
    Object.keys(customized_data).map((index) => {
      if (key == 'training_course')
      {
        let coupon_training_course_id = index.replace(/training_course_/g, "");
        Object.keys(cart_index_with_learner).map((cart_index) => {
          if (cart_index.includes('booking_event') && cart_index_with_learner[cart_index].course_id == coupon_training_course_id) {
            set_learners.total      = set_learners.total  + cart_index_with_learner[cart_index].total_member;
            set_learners.member     = set_learners.member + cart_index_with_learner[cart_index].count_member_learner;
            set_learners.non_member = set_learners.non_member + cart_index_with_learner[cart_index].count_non_member_learner;
          }
        })
      } else {
        if (key == 'training_event')
        {
          index = index.replace(/training_event_/g, "booking_event_");
        }
        if (index in cart_index_with_learner)
        {
          set_learners.total      = set_learners.total  + cart_index_with_learner[index].total_member;
          set_learners.member     = set_learners.member + cart_index_with_learner[index].count_member_learner;
          set_learners.non_member = set_learners.non_member + cart_index_with_learner[index].count_non_member_learner;
        }
      }
    });
    return set_learners;
  }

  render() {
    
    var priceObj = this.state.priceObj;
    var { cartcount, carttotal } = this.state;
    var cartdiscount = priceObj.total_dis;
    var coupondiscount = priceObj.total_cp_dis;
    carttotal = priceObj.total_main_price;
  // carttotal 					= priceObj.total_main_price;
    var taxamount = priceObj.total_tax;
    var tax_type = priceObj.tax_type;



    coupondiscount = Math.round((coupondiscount + Number.EPSILON) * 100) / 100;
    if (__prev_dis == coupondiscount) {
      this.state.showpopup2 = false;
    }

    // FOR COUPON DETAIL
    var coupon_detail = {
      is_subscriber_limit: false,
      is_bulk_enable: false,
      coupon_type: '',
      coupon_option: 0,
      coupon_limit: '',
      number_learner_count: 0
    };
    if (_couponApplied.data != null && Number(_couponApplied.data.pc_subscriber_coupons_limit) > 0) {
      
      coupon_detail.is_subscriber_limit = (_couponApplied.data.pc_subscriber_coupons_limit) ? true : false;
      coupon_detail.coupon_type         = _couponApplied.data.pc_coupon_type;
      coupon_detail.coupon_option       = _couponApplied.data.pc_coupon_option;
      coupon_detail.coupon_limit        = _couponApplied.data.pc_subscriber_coupons_remaining;

      if (_couponApplied.data.pc_discount_type == 1) {
        coupon_detail.is_bulk_enable = (_couponApplied.data.pc_is_bulk_learner_price == 1) ? true : false;
      } else {
        coupon_detail.is_bulk_enable = (_couponApplied.data.pc_is_bulk_learner_percent == 1) ? true : false;
      }

    }
    taxamount = Math.round((taxamount + Number.EPSILON) * 100) / 100;
    var checkoutprice = priceObj.total_price;
    checkoutprice = Math.round((checkoutprice + Number.EPSILON) * 100) / 100;
    carttotal = Math.round((carttotal + Number.EPSILON) * 100) / 100;
    cartdiscount = Math.round((cartdiscount + Number.EPSILON) * 100) / 100;

    // FOR TOTAL COUNT LEARNER
    var all_member_learner = 0;
    var all_non_member_learner = 0;
    var count_member_learner = 0;
    var count_non_member_learner = 0;
    var total_member = 0;
    var cart_item_key_with_learner_count = {}

    const learner_cart = JSON.parse(localStorage.getItem('mycart'));
    Object.keys(learner_cart).map((index) => {
      if (Object.keys(learner_cart[index].learners).length > 0) {
        if (total_member !== 0)
        {
          // RESETTING TO ZERO
          count_member_learner = 0;
          count_non_member_learner = 0;
          total_member = 0;
        }
        Object.keys(learner_cart[index].learners).map((items) => {
          if (
            learner_cart[index].learners[items]['is_member'] == '1' &&
            _showMember == '1' &&
            learner_cart[index].others.member_status == '1'
          ) {
              ++all_member_learner;
              ++count_member_learner;
              ++total_member;
          } else {
              ++all_non_member_learner;
              ++count_non_member_learner;
              ++total_member;
          }
          cart_item_key_with_learner_count = {
            ...cart_item_key_with_learner_count,
            [index]: {
              total_member: total_member,
              count_member_learner: count_member_learner,
              count_non_member_learner: count_non_member_learner,
              course_id: (learner_cart[index].course_id) ? learner_cart[index].course_id : 0
            }
          }

        })
      }
    });
    // FOR TOTAL COUNT LEARNER

    // FOR LIMIT LEARNER MESSAGE
    if (_bfo == 1)
    {
      if (_couponApplied.slug)
      {
        let coupon_option = _couponApplied.data.pc_coupon_option;
        // CUSTOMIZED COUPON
        if (_couponApplied.data.pc_coupon_type == 1)
        {   
            let customized_data = JSON.parse(_couponApplied.data.pc_customized_data);
            let total           = this.findLearnerInCustomizedCartItems(customized_data, cart_item_key_with_learner_count);
          
            coupon_detail.number_learner_count = (coupon_option == 2) ? total.total  : ((coupon_option == 1) ? total.member : total.non_member);
        } else {
            coupon_detail.number_learner_count = (coupon_option == 2) ? Number(all_member_learner) + Number(all_non_member_learner)  : ((coupon_option == 1) ? all_member_learner : all_non_member_learner);
        }
      }
    }
    
    return (
      <div className="cart-rght-box  sm-reverse-flex">
        {this.state.couponNotAllowed ?
          (<CouponNotAllowed
            removeCoupon={this.removeCoupon}
            cb_dismiss={() => this.setState({ couponNotAllowed: false })}
          />
        ) : ('')}
        {this.state.showpopup2 && coupondiscount ?  (
          <CouponApplied
            coupondiscount={coupondiscount}
            cb_dismiss={this.removeCouponAppliedpopup}
            not_applicable={this.props.data}
            removeCoupon={this.removeCoupon}
            coupon_detail={typeof coupon_detail != 'undefined' ? coupon_detail : 0}
            is_bfo={_bfo==0 ? true : false}
            total_member={( typeof count_member_learner != 'undefined' ? count_member_learner : 0)}
            total_non_member={(typeof count_non_member_learner != 'undefined' ? count_non_member_learner : 0)}
          />
        ) : (
          <div></div>
        )}
        {this.state.showpopup && (
          <CouponModal
            global_coupon={this.props.data.global_coupon}
            applyCoupon={this.applyCoupon}
            cb_dismiss={() => this.setState({ showpopup: false })}
            updateCheckoutState={this.updatingCheckoutState}
          />
        )}
        {!_couponApplied.slug ? (
          <div className="apply-coupon">
            <div className="d-flex apply-text" onClick={this.showCoupons}>
              <span className="tag-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={17}
                  viewBox="0 0 21.35 21.167"
                >
                  <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M20.59,13.41l-7.17,7.17a2,2,0,0,1-2.83,0L2,12V2H12l8.59,8.59A2,2,0,0,1,20.59,13.41Z"
                    transform="translate(-1 -1)"
                    fill="none"
                    stroke="#1b1c21"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                  />
                  <line
                    id="Line_3"
                    data-name="Line 3"
                    x2="0.01"
                    transform="translate(6 6)"
                    fill="none"
                    stroke="#1b1c21"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                  />
                </svg>
              </span>
              Apply Coupon
            </div>
            <div className="apply-small-text" style={{ width: '100%' }}>
              Enter the coupon code to avail a discount on your order.
            </div>
          </div>
        ) : (
          <div className="apply-coupon-sec">
            <div className="d-flex coupon-text">
              <span className="tag-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={17}
                  /*height="auto"*/
                  viewBox="0 0 21.35 21.167"
                >
                  <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M20.59,13.41l-7.17,7.17a2,2,0,0,1-2.83,0L2,12V2H12l8.59,8.59A2,2,0,0,1,20.59,13.41Z"
                    transform="translate(-1 -1)"
                    fill="none"
                    stroke="#1b1c21"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                  />
                  <line
                    id="Line_3"
                    data-name="Line 3"
                    x2="0.01"
                    transform="translate(6 6)"
                    fill="none"
                    stroke="#1b1c21"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                  />
                </svg>
              </span>
              Coupon
            </div>
            <p className="cart-coupon-type">
              {_couponApplied.data.pc_coupon_type == 1 ? 'Custom' : ' Platform'}{' '}
              Coupon Applied
            </p>
            <div className="cart-couponstatus-wrapper">
              <div className="cart-summary-title">
                <strong>
                  {(_couponApplied.slug ? _couponApplied.data.pc_name + ' Coupon' : ' ')}{' '}
                </strong>
              </div>
              <div className="cs-discount-detail d-flex align-center justify-content-between mb-1 w-100">
                <div className="green-text w-100">
                  <b className="d-flex align-center justify-content-between gap-2">
                    <span>Discount {(_couponApplied.slug && _couponApplied.data.pc_discount_type == 1) ? 'Rate' : 'Percentage'}{' : '}</span>
                    <span>{(_couponApplied.slug && _couponApplied.data.pc_discount_type == 1) ? current_currency + _couponApplied.data.pc_discount_rate : _couponApplied.data.pc_discount_rate+'%'}</span>
                  </b>{' '}
                </div>
              </div>
              <div className="cs-maxdiscount-detail d-flex align-center justify-content-between mb-1 w-100">
                <div className="green-text w-100">
                  {((_couponApplied.slug && _couponApplied.data.pc_discount_type == 0 && _couponApplied.data.pc_maximum_discount) ?
                    <b className="d-flex align-center justify-content-between gap-2">
                      <span>{'Maximum Discount :'}</span>
                      <span>{current_currency + _couponApplied.data.pc_maximum_discount}</span>
                    </b> :
                    '')
                  }
                </div>
              </div>
              <div className="d-flex align-center justify-content-between mb-1 w-100" style={{color:"red"}}>
                  { _couponApplied.slug && coupondiscount == 0 ?
                    (
                      <>
                      <p>{_couponApplied.code + ' Coupon not applicable'}
                         <br/>{(coupon_detail && coupon_detail.is_bulk_enable === false && _bfo == 1) ? 'Coupon not Enabled Bulk Subscriber' : ''}
                      </p>
                      
                        <span className="coupon-close" onClick={this.removeCoupon}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10.079"
                          height="10.061"
                          viewBox="0 0 10.079 10.061"
                        >
                          <g
                            id="noun_Close_4046821"
                            transform="translate(-3.489 -18.576)"
                          >
                            <g
                              id="Group_38"
                              data-name="Group 38"
                              transform="translate(4 19.076)"
                            >
                              <path
                                id="Path_41"
                                data-name="Path 41"
                                d="M4.758,4a.754.754,0,0,0-.525,1.294l3.228,3.23L4.237,11.75A.753.753,0,1,0,5.3,12.816L8.526,9.589l3.224,3.226a.753.753,0,1,0,1.065-1.065L9.591,8.524l3.228-3.229a.754.754,0,1,0-1.065-1.066L8.526,7.459,5.3,4.229A.753.753,0,0,0,4.758,4Z"
                                transform="translate(-4 -4)"
                                fill="#76ad94"
                                stroke="#76ad94"
                                strokeWidth={1}
                                fillRule="evenodd"
                              />
                            </g>
                          </g>
                        </svg>
                      </span>
                      </>
                    )
                    : ''
                  }
              </div>
              {
                _bfo == 1 && total_member == 0 ?
                  (
                  <div className="apply-coupon-box" style={{backgroundColor:"#f02b2b1f"}}>
                    <p>Please add learners to apply `{_couponApplied.code }` Coupon</p>
                    <span className="coupon-close" onClick={this.removeCoupon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10.079"
                        height="10.061"
                        viewBox="0 0 10.079 10.061"
                      >
                        <g
                          id="noun_Close_4046821"
                          transform="translate(-3.489 -18.576)"
                        >
                          <g
                            id="Group_38"
                            data-name="Group 38"
                            transform="translate(4 19.076)"
                          >
                            <path
                              id="Path_41"
                              data-name="Path 41"
                              d="M4.758,4a.754.754,0,0,0-.525,1.294l3.228,3.23L4.237,11.75A.753.753,0,1,0,5.3,12.816L8.526,9.589l3.224,3.226a.753.753,0,1,0,1.065-1.065L9.591,8.524l3.228-3.229a.754.754,0,1,0-1.065-1.066L8.526,7.459,5.3,4.229A.753.753,0,0,0,4.758,4Z"
                              transform="translate(-4 -4)"
                              fill="#76ad94"
                              stroke="#76ad94"
                              strokeWidth={1}
                              fillRule="evenodd"
                            />
                          </g>
                        </g>
                      </svg>
                    </span>
                  </div>
                  )
                  : ''
              }
              <br/>
              {
                coupondiscount != 0 ?
                (<div className="d-flex align-center justify-content-between mb-1 w-100">
                  <div className="green-text">
                    <b>
                      You saved <span className="cs-saved-amt">{current_currency}
                      {coupondiscount}</span>
                    </b>{' '}
                  </div>
                  <div className="apply-coupon-box">
                    {_couponApplied.code}{' '}
                    <span className="coupon-close" onClick={this.removeCoupon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10.079"
                        height="10.061"
                        viewBox="0 0 10.079 10.061"
                      >
                        <g
                          id="noun_Close_4046821"
                          transform="translate(-3.489 -18.576)"
                        >
                          <g
                            id="Group_38"
                            data-name="Group 38"
                            transform="translate(4 19.076)"
                          >
                            <path
                              id="Path_41"
                              data-name="Path 41"
                              d="M4.758,4a.754.754,0,0,0-.525,1.294l3.228,3.23L4.237,11.75A.753.753,0,1,0,5.3,12.816L8.526,9.589l3.224,3.226a.753.753,0,1,0,1.065-1.065L9.591,8.524l3.228-3.229a.754.754,0,1,0-1.065-1.066L8.526,7.459,5.3,4.229A.753.753,0,0,0,4.758,4Z"
                              transform="translate(-4 -4)"
                              fill="#76ad94"
                              stroke="#76ad94"
                              strokeWidth={1}
                              fillRule="evenodd"
                            />
                          </g>
                        </g>
                      </svg>
                    </span>
                  </div>
                </div>) :
                ''
              }
              
            </div>
          </div>
        )}
        <div className="border-bottom sm-none"></div>
        <div className="cart-order-details">
          <h5 className="mb-2 mt-2">Order Details</h5>
          <div className="cart-price-list">
            <div className="d-flex justify-content-between mb-1 w-100">
              {/* <div>Total Price({cartcount} Item) </div> */}
              <div>Gross Total </div>
              <div>
                {current_currency}
                {carttotal}
              </div>
            </div>
            {/* ( {taxpercent}%) */}
            <div className="d-flex justify-content-between mb-1 w-100">
              <div>Product Discount </div>
              <div className="green-text">
                - {current_currency}
                {cartdiscount}
              </div>
            </div>
            <div className="d-flex justify-content-between mb-1 w-100">
              <div>Sub Total </div>
              <div>
                {current_currency}
                {carttotal - cartdiscount}
              </div>
            </div>
            <div className="d-flex justify-content-between mb-1 w-100">
              <div>Coupon Discount </div>
              <div className="text-blue">
                - {current_currency}
                {coupondiscount}{' '}
              </div>
            </div>
            <div className="d-flex justify-content-between mb-1 w-100">
              <div>Sub Total After Discount </div>
              <div>
                {' '}
                {current_currency}
                {carttotal - (coupondiscount + cartdiscount)}{' '}
              </div>
            </div>
            <div className="d-flex justify-content-between mb-1 w-100">
              <div>
                <span>
                  {__taxLabel} Applied{' '}
                  <span className="tax-tooltip">
                    i
                    <span className="tax_tooltip_content">
                      Tax is calculated only on products exclusive of tax and
                      not on tax-free or tax-inclusive products.
                    </span>
                  </span>
                </span>
              </div>
              <div>
                {current_currency}
                {taxamount <= 0 ? 0 : taxamount}{' '}
              </div>
            </div>
            <div className="border-bottom mb-15 mt-2 sm-none" />
          </div>
        </div>
        <div className="order-details-btm">
          <div className="d-flex align-center justify-content-between mb-1 w-100">
            <div>
              <b>Grand Total</b>{' '}
            </div>
            <div className="total-amount">
              <b>
                {current_currency}
                {checkoutprice <= 0 ? 0 : checkoutprice}
              </b>{' '}
            </div>
          </div>
          {/* for free price items purchase */}
          {checkoutprice <= 0 ? (
            <div
              className="btn checkout-btn h-45 mt-1 theme-blue-btn1 orange-flat-btn w-100"
              onClick={() => this.checkOut(null)}
            >
              {_free_course_btn_label}
            </div>
          ) : (
            <div
              className="btn apply-cart-btn orange-flat-btn mt-1 theme-blue-btn1 w-100"
              onClick={() => this.checkOut(null)}
            >
              Checkout
            </div>
          )}

          {/* #details-pps */}
        </div>
        {this.state.showEmilVerifyModal && (
          <EmailVerificationCheckModal
            ppsRequired={this.props.data.ppsRequired}
            closeCallBack={() => this.EmailVerifyModalClose()}
            callBackEamilVerify={this.callBackEamilVerify}
            callBackEmailVerifySkip={this.callBackEmailVerifySkip}
          />
        )}
        {/* {this.state.showPpsModal && <PpsModal govtIdCardLablel={this.state.govtIdCardLablel} closeCallBack={() => this.PpsModalClose()} checkOutProccessCall={this.checkOutProccessCall} ppsSkipCheckOutProccessCall={this.ppsSkipCheckOutProccessCall} />} */}
        {this.state.showPpsModal && (
          <AddLearner
            submit={(data) => this.checkOut(data)}
            dissmissmodal={this.PpsModalClose}
          />
        )}
        {/* showCheckOutValidateModalData */}
        {/* {this.state.showCartItemValidateModal && <CartItemsValidate expiredCartItems={this.state.expiredCartItems} closeCallBack={() => this.setState({ showCartItemValidateModal: !this.state.showCartItemValidateModal })} ReviewedCartContinueCallBack={this.ReviewedCartContinueCallBack} />} */}
        {this.state.showCheckOutValidateModal && (
          <CheckOutValidateModal
            removeCoupon={this.removeCoupon}
            errorData={this.state.showCheckOutValidateModalData}
            closeCallBack={() =>
              this.setState({
                showCheckOutValidateModal:
                  !this.state.showCheckOutValidateModal,
              })
            }
          />
        )}
      </div>
    );
  }
}